/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation, GraphQLResult } from "@aws-amplify/api-graphql";
import { Observable } from "zen-observable-ts";

export interface SubscriptionResponse<T> {
  value: GraphQLResult<T>;
}

export type __SubscriptionContainer = {
  onCreateInvoice: OnCreateInvoiceSubscription;
  onUpdateInvoice: OnUpdateInvoiceSubscription;
  onUpdateUser: OnUpdateUserSubscription;
  onDeleteUser: OnDeleteUserSubscription;
  onUpdateClient: OnUpdateClientSubscription;
  onCreateFolder: OnCreateFolderSubscription;
  onUpdateFolder: OnUpdateFolderSubscription;
  onUpdateInvoiceUserAssignment: OnUpdateInvoiceUserAssignmentSubscription;
  onUpdateFolderScanTask: OnUpdateFolderScanTaskSubscription;
  onCreateInvoiceScanTask: OnCreateInvoiceScanTaskSubscription;
  onUpdateInvoiceScanTask: OnUpdateInvoiceScanTaskSubscription;
  onDeleteInvoiceScanTask: OnDeleteInvoiceScanTaskSubscription;
  onCreateCodebook: OnCreateCodebookSubscription;
  onUpdateCodebook: OnUpdateCodebookSubscription;
  onDeleteCodebook: OnDeleteCodebookSubscription;
  onCreateTemplate: OnCreateTemplateSubscription;
  onUpdateTemplate: OnUpdateTemplateSubscription;
  onDeleteTemplate: OnDeleteTemplateSubscription;
  onCreateSystemConfiguration: OnCreateSystemConfigurationSubscription;
  onUpdateSystemConfiguration: OnUpdateSystemConfigurationSubscription;
  onDeleteSystemConfiguration: OnDeleteSystemConfigurationSubscription;
  onCreateWorker: OnCreateWorkerSubscription;
  onUpdateWorker: OnUpdateWorkerSubscription;
  onDeleteWorker: OnDeleteWorkerSubscription;
  onUpdateMapperConfiguration: OnUpdateMapperConfigurationSubscription;
  onDeleteMapperConfiguration: OnDeleteMapperConfigurationSubscription;
  onCreateFiaReportJob: OnCreateFiaReportJobSubscription;
  onUpdateFiaReportJob: OnUpdateFiaReportJobSubscription;
  onDeleteFiaReportJob: OnDeleteFiaReportJobSubscription;
};

export type DownloadFiaReportInput = {
  id: string;
};

export type FiaReportJob = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<SelectedColumn | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: Client | null;
  exportedFileUrl?: string | null;
  missingKeys?: MissingKeys | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

export enum FiaReportJobStatus {
  INIT = "INIT",
  TABLE_EXTRACTED = "TABLE_EXTRACTED",
  CREATING = "CREATING",
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
  EXPORTING = "EXPORTING",
  EXPORTED = "EXPORTED"
}

export enum FiaReportSourceType {
  GOOGLE_DOC = "GOOGLE_DOC",
  PDF_FILE = "PDF_FILE",
  XLSX = "XLSX",
  DOC = "DOC",
  DOCX = "DOCX",
  RTF = "RTF"
}

export type SelectedColumn = {
  __typename: "SelectedColumn";
  fieldType: FiaReportFieldType;
  index?: number | null;
  columnName?: string | null;
};

export enum FiaReportFieldType {
  TOTAL = "TOTAL",
  DEMANDED = "DEMANDED",
  DIFFERENCE = "DIFFERENCE"
}

export type Client = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  folders?: ModelFolderConnection | null;
  folderScanTasks?: ModelFolderScanTaskConnection | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: User | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
  cicDriveFileId?: string | null;
};

export type ModelFolderConnection = {
  __typename: "ModelFolderConnection";
  items: Array<Folder | null>;
  nextToken?: string | null;
};

export type Folder = {
  __typename: "Folder";
  id: string;
  name: string;
  searchKeyword?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  invoices?: ModelInvoiceConnection | null;
  latestFolderInvoiceTask?: FolderScanTask | null;
  folderScanTasks?: ModelFolderScanTaskConnection | null;
  exportStatus?: FolderExportStatus | null;
  latestCompletedAt?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  parentFolderID?: string | null;
  parentFolder?: Folder | null;
  childFolders?: ModelFolderConnection | null;
  clientIDParentFolderIDPK?: string | null;
  isDeleted?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export enum ScanStatus {
  INIT = "INIT",
  IN_QUEUE = "IN_QUEUE",
  IN_PROCESSING = "IN_PROCESSING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  CANCELED = "CANCELED"
}

export type ModelInvoiceConnection = {
  __typename: "ModelInvoiceConnection";
  items: Array<Invoice | null>;
  nextToken?: string | null;
};

export type Invoice = {
  __typename: "Invoice";
  id: string;
  name: string;
  folderID: string;
  folderIDIsDeletedPK?: string | null;
  clientID: string;
  folder?: Folder | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  invoiceScanTasks?: ModelInvoiceScanTaskConnection | null;
  index: number;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  rotateAngle: number;
  invoiceUserAssignments?: ModelInvoiceUserAssignmentConnection | null;
  createdAt: string;
  updatedAt: string;
  nanonets?: NanonetsInfo | null;
  nanonetsID?: string | null;
  title?: string | null;
  searchToken?: string | null;
  isDeleted?: boolean | null;
};

export type ModelInvoiceScanTaskConnection = {
  __typename: "ModelInvoiceScanTaskConnection";
  items: Array<InvoiceScanTask | null>;
  nextToken?: string | null;
};

export type InvoiceScanTask = {
  __typename: "InvoiceScanTask";
  id: string;
  invoiceID?: string | null;
  invoice?: Invoice | null;
  folderScanTaskID?: string | null;
  folderScanTask?: FolderScanTask | null;
  folderID?: string | null;
  folder?: Folder | null;
  createdByID?: string | null;
  client?: Client | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  worker?: Worker | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type FolderScanTask = {
  __typename: "FolderScanTask";
  id: string;
  folderID?: string | null;
  folder?: Folder | null;
  clientID?: string | null;
  client?: Client | null;
  taskCount?: number | null;
  processedTaskCount?: number | null;
  failedTaskCount?: number | null;
  executionTime?: number | null;
  logMessages?: string | null;
  status?: ScanStatus | null;
  extractedResults?: string | null;
  missingFieldsCount?: number | null;
  invoiceScanTasks?: ModelInvoiceScanTaskConnection | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export enum TF {
  TRUE = "TRUE",
  FALSE = "FALSE"
}

export type Worker = {
  __typename: "Worker";
  id: string;
  name: string;
  status: WorkerStatus;
  createdAt: string;
  updatedAt: string;
};

export enum WorkerStatus {
  STARTED = "STARTED",
  PROCESSING = "PROCESSING",
  IDLE = "IDLE",
  STOPPED = "STOPPED"
}

export type ModelInvoiceUserAssignmentConnection = {
  __typename: "ModelInvoiceUserAssignmentConnection";
  items: Array<InvoiceUserAssignment | null>;
  nextToken?: string | null;
};

export type InvoiceUserAssignment = {
  __typename: "InvoiceUserAssignment";
  id: string;
  invoiceID: string;
  invoice?: Invoice | null;
  clientID: string;
  client?: Client | null;
  email: string;
  role?: string | null;
  notified: TF;
  createdAt: string;
  updatedAt: string;
};

export type NanonetsInfo = {
  __typename: "NanonetsInfo";
  previewUrl?: string | null;
  fileID?: string | null;
  modelID?: string | null;
  expiresAt?: number | null;
  redirectUrl?: string | null;
};

export type ModelFolderScanTaskConnection = {
  __typename: "ModelFolderScanTaskConnection";
  items: Array<FolderScanTask | null>;
  nextToken?: string | null;
};

export enum FolderExportStatus {
  REORDER_PROCESSING = "REORDER_PROCESSING",
  READY = "READY"
}

export enum ClientStatus {
  ACTIVE = "ACTIVE",
  TRIAL = "TRIAL",
  DISABLED = "DISABLED"
}

export type User = {
  __typename: "User";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  status?: ClientStatus | null;
  type: UserType;
  createdAt: string;
  updatedAt: string;
};

export enum UserType {
  CLIENT = "CLIENT",
  ADMIN = "ADMIN"
}

export enum ClientFiaAccessStatus {
  ACTIVE = "ACTIVE",
  TRIAL = "TRIAL",
  DISABLED = "DISABLED",
  FULL_ACCESS = "FULL_ACCESS"
}

export type MissingKeys = {
  __typename: "MissingKeys";
  keys?: string | null;
  dismissed?: number | null;
};

export enum CompanyType {
  NGO = "NGO",
  STANDARD_COMPANY = "STANDARD_COMPANY"
}

export type UpdateClientStatusInput = {
  status: ClientFiaAccessStatus;
  id: string;
};

export type GenerateFiaReportInput = {
  previousSpreadsheetUrl?: string | null;
  skipColumnSelection?: boolean | null;
  source: ReportSourceFile;
  permissionToEmail?: string | null;
  token?: string | null;
  companyName?: string | null;
  companyType?: CompanyType | null;
};

export type ReportSourceFile = {
  googleDocId?: string | null;
  pdfFileUrl?: string | null;
  fileName?: string | null;
  sourceType: FiaReportSourceType;
  sourceFileUrl?: string | null;
};

export type CompleteFiaReportInput = {
  id: string;
};

export type SqsStatus = {
  __typename: "SqsStatus";
  statusCode?: number | null;
  body?: string | null;
  headers?: string | null;
};

export type ExportFiaReportInput = {
  id: string;
};

export type ProcessCICReportInput = {
  invoiceID: string;
  templateID: string;
};

export type ProcessCICReportMutation = {
  __typename: "SqsStatus";
  statusCode?: number | null;
  body?: string | null;
  headers?: string | null;
};

export type GeneratePreviewUrlInput = {
  invoiceID: string;
  redirectUrl?: string | null;
};

export type PredictFolderInput = {
  folderID: string;
  redirectUrl?: string | null;
};

export type PredictFolderOutput = {
  __typename: "PredictFolderOutput";
  invoices?: Array<Invoice | null> | null;
};

export type TestExceptionIdentityInput = {
  identities: Array<IdentityInput | null>;
  invoiceID: string;
};

export type IdentityInput = {
  key?: string | null;
  value?: string | null;
};

export type TestExceptionIdentityOutput = {
  __typename: "TestExceptionIdentityOutput";
  matchedIdentities: Array<Identity | null>;
};

export type Identity = {
  __typename: "Identity";
  key: string;
  value: string;
};

export type IncrementClientCountersInput = {
  id: string;
  inputTokenCount?: number | null;
  inputSpentCount?: number | null;
  outputTokenCount?: number | null;
  outputSpentCount?: number | null;
  totalSpentCount?: number | null;
  totalScanCount?: number | null;
  totalFiaReportProcessCount?: number | null;
  downloadQuota?: number | null;
  reportQuota?: number | null;
};

export type CreateClientInput = {
  id?: string | null;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  password?: string | null;
  phone: string;
  address?: string | null;
  city?: string | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
};

export type ModelClientConditionInput = {
  username?: ModelStringInput | null;
  email?: ModelStringInput | null;
  company?: ModelStringInput | null;
  phone?: ModelStringInput | null;
  address?: ModelStringInput | null;
  city?: ModelStringInput | null;
  and?: Array<ModelClientConditionInput | null> | null;
  or?: Array<ModelClientConditionInput | null> | null;
  not?: ModelClientConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelCreateFolderScanTaskInput = {
  folderID: string;
  isScanIncludedProducts?: TF | null;
};

export type ModelAppendFolderScanTaskLogMessageInput = {
  folderScanTaskID: string;
  logMessage?: string | null;
};

export type ModelCreatePresignedURLInput = {
  action: string;
  profile: string;
  originalFileName: string;
};

export type ModelCreatePresignedURLDataOutput = {
  __typename: "ModelCreatePresignedURLDataOutput";
  url?: string | null;
  filePath?: string | null;
  mimeType?: string | null;
};

export type ModelCancelFolderScanTaskInput = {
  folderID: string;
};

export type ModelCancelFolderScanTaskOutput = {
  __typename: "ModelCancelFolderScanTaskOutput";
  result?: string | null;
};

export type ModelBulkCodebookImportInput = {
  csvUrl: string;
};

export type ModelBulkCodebookImportOutput = {
  __typename: "ModelBulkCodebookImportOutput";
  result: string;
  message?: string | null;
};

export type ModelBulkInvoiceDeleteInput = {
  invoices: Array<string>;
};

export type ModelBulkInvoiceDeleteOutput = {
  __typename: "ModelBulkInvoiceDeleteOutput";
  result: string;
  message?: string | null;
};

export type ModelSendEmailInput = {
  fromAddress: string;
  toAddresses: Array<string>;
  subject: string;
  content: string;
};

export type ModelSendEmailOutput = {
  __typename: "ModelSendEmailOutput";
  result: string;
  message?: string | null;
};

export type ModelContactFormInput = {
  email: string;
  phoneNumber: string;
  message?: string | null;
};

export type ModelContactFormOutput = {
  __typename: "ModelContactFormOutput";
  result: string;
  message?: string | null;
};

export type ModelCreateTrialUserInput = {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  password: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  isVatIncluded: TF;
};

export type CreateMapperConfigurationInput = {
  id?: string | null;
  clientID?: string | null;
  type: MapConfigurationType;
  configuration: string;
};

export enum MapConfigurationType {
  SYSTEM = "SYSTEM",
  INVOICE_EXCEPTIONS = "INVOICE_EXCEPTIONS",
  FIELD_CLEANUP = "FIELD_CLEANUP",
  CUSTOM = "CUSTOM"
}

export type MapperConfiguration = {
  __typename: "MapperConfiguration";
  id: string;
  clientID?: string | null;
  type: MapConfigurationType;
  configuration: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type HandleKeysInput = {
  operation?: HandleKeyOperation | null;
  keys?: Array<Key | null> | null;
};

export enum HandleKeyOperation {
  ADD = "ADD",
  RESOLVE = "RESOLVE"
}

export type Key = {
  scannedKey?: string | null;
  mappedTo?: string | null;
};

export type HandleKeysOutput = {
  __typename: "HandleKeysOutput";
  success?: boolean | null;
};

export type CreateInvoiceInput = {
  id?: string | null;
  name: string;
  folderID: string;
  clientID: string;
  extractedResults?: string | null;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  index?: number | null;
  rotateAngle?: number | null;
  nanonets?: NanonetsInfoInput | null;
  nanonetsID?: string | null;
  title?: string | null;
};

export type NanonetsInfoInput = {
  previewUrl?: string | null;
  fileID?: string | null;
  modelID?: string | null;
  expiresAt?: number | null;
  redirectUrl?: string | null;
};

export type ModelInvoiceConditionInput = {
  name?: ModelStringInput | null;
  folderID?: ModelIDInput | null;
  clientID?: ModelIDInput | null;
  extractedResults?: ModelStringInput | null;
  missingFields?: ModelStringInput | null;
  thumbnailPath?: ModelStringInput | null;
  and?: Array<ModelInvoiceConditionInput | null> | null;
  or?: Array<ModelInvoiceConditionInput | null> | null;
  not?: ModelInvoiceConditionInput | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type UpdateInvoiceInput = {
  id: string;
  name?: string | null;
  folderID?: string | null;
  clientID?: string | null;
  extractedResults?: string | null;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  index?: number | null;
  rotateAngle?: number | null;
  nanonets?: NanonetsInfoInput | null;
  nanonetsID?: string | null;
  title?: string | null;
};

export type DeleteFolderInput = {
  id: string;
};

export type ModelFolderConditionInput = {
  name?: ModelStringInput | null;
  clientID?: ModelIDInput | null;
  downloadLink?: ModelStringInput | null;
  status?: ModelScanStatusInput | null;
  latestFolderInvoiceTaskID?: ModelIDInput | null;
  areThereMissingFields?: ModelBooleanInput | null;
  invoicesCount?: ModelIntInput | null;
  and?: Array<ModelFolderConditionInput | null> | null;
  or?: Array<ModelFolderConditionInput | null> | null;
  not?: ModelFolderConditionInput | null;
};

export type ModelScanStatusInput = {
  eq?: ScanStatus | null;
  ne?: ScanStatus | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type DeleteClientInput = {
  id: string;
};

export type DeleteInvoiceInput = {
  id: string;
};

export type BulkDeleteServiceInput = {
  type?: ModelType | null;
  ids?: Array<string | null> | null;
};

export enum ModelType {
  CLIENT = "CLIENT",
  INVOICE = "INVOICE",
  FOLDER = "FOLDER",
  CODEBOOK = "CODEBOOK",
  TEMPLATE = "TEMPLATE"
}

export type BulkDeleteServiceOutput = {
  __typename: "BulkDeleteServiceOutput";
  success?: boolean | null;
  message?: string | null;
};

export type CreateUserInput = {
  id?: string | null;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  status?: ClientStatus | null;
  type: UserType;
};

export type UpdateInvoicePositionInput = {
  invoiceID?: string | null;
  position?: number | null;
};

export type QueueMessageResponse = {
  __typename: "QueueMessageResponse";
  success?: string | null;
};

export type CreateInvoiceUserAssignmentInput = {
  invoiceID: string;
  clientID: string;
  email: string;
  role?: string | null;
  notified?: TF | null;
};

export type UpdateUserInput = {
  id: string;
  username?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  company?: string | null;
  phone?: string | null;
  address?: string | null;
  status?: ClientStatus | null;
  type?: UserType | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ModelUserConditionInput = {
  username?: ModelStringInput | null;
  email?: ModelStringInput | null;
  firstName?: ModelStringInput | null;
  lastName?: ModelStringInput | null;
  company?: ModelStringInput | null;
  phone?: ModelStringInput | null;
  address?: ModelStringInput | null;
  status?: ModelClientStatusInput | null;
  type?: ModelUserTypeInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelUserConditionInput | null> | null;
  or?: Array<ModelUserConditionInput | null> | null;
  not?: ModelUserConditionInput | null;
};

export type ModelClientStatusInput = {
  eq?: ClientStatus | null;
  ne?: ClientStatus | null;
};

export type ModelUserTypeInput = {
  eq?: UserType | null;
  ne?: UserType | null;
};

export type DeleteUserInput = {
  id: string;
};

export type UpdateClientInput = {
  id: string;
  username?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  company?: string | null;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type CreateFolderInput = {
  id?: string | null;
  name: string;
  searchKeyword?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  exportStatus?: FolderExportStatus | null;
  latestCompletedAt?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  parentFolderID?: string | null;
  clientIDParentFolderIDPK?: string | null;
  isDeleted?: boolean | null;
};

export type UpdateFolderInput = {
  id: string;
  name?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  latestCompletedAt?: string | null;
  exportStatus?: FolderExportStatus | null;
  parentFolderID?: string | null;
  isLatestScanIncludedProducts?: TF | null;
};

export type UpdateInvoiceUserAssignmentInput = {
  id: string;
  invoiceID?: string | null;
  clientID?: string | null;
  email?: string | null;
  role?: string | null;
  notified?: TF | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ModelInvoiceUserAssignmentConditionInput = {
  invoiceID?: ModelIDInput | null;
  clientID?: ModelIDInput | null;
  email?: ModelStringInput | null;
  role?: ModelStringInput | null;
  notified?: ModelTFInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelInvoiceUserAssignmentConditionInput | null> | null;
  or?: Array<ModelInvoiceUserAssignmentConditionInput | null> | null;
  not?: ModelInvoiceUserAssignmentConditionInput | null;
};

export type ModelTFInput = {
  eq?: TF | null;
  ne?: TF | null;
};

export type UpdateFolderScanTaskInput = {
  id: string;
  folderID?: string | null;
  clientID?: string | null;
  taskCount?: number | null;
  processedTaskCount?: number | null;
  failedTaskCount?: number | null;
  executionTime?: number | null;
  logMessages?: string | null;
  status?: ScanStatus | null;
  extractedResults?: string | null;
  missingFieldsCount?: number | null;
  isScanIncludedProducts?: TF | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ModelFolderScanTaskConditionInput = {
  folderID?: ModelIDInput | null;
  clientID?: ModelIDInput | null;
  taskCount?: ModelIntInput | null;
  processedTaskCount?: ModelIntInput | null;
  failedTaskCount?: ModelIntInput | null;
  executionTime?: ModelFloatInput | null;
  logMessages?: ModelStringInput | null;
  status?: ModelScanStatusInput | null;
  extractedResults?: ModelStringInput | null;
  missingFieldsCount?: ModelIntInput | null;
  isScanIncludedProducts?: ModelTFInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelFolderScanTaskConditionInput | null> | null;
  or?: Array<ModelFolderScanTaskConditionInput | null> | null;
  not?: ModelFolderScanTaskConditionInput | null;
};

export type ModelFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type CreateInvoiceScanTaskInput = {
  id?: string | null;
  invoiceID?: string | null;
  folderScanTaskID?: string | null;
  folderID?: string | null;
  createdByID?: string | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
};

export type ModelInvoiceScanTaskConditionInput = {
  invoiceID?: ModelIDInput | null;
  folderScanTaskID?: ModelIDInput | null;
  folderID?: ModelIDInput | null;
  createdByID?: ModelIDInput | null;
  logMessages?: ModelStringInput | null;
  queueID?: ModelStringInput | null;
  workerID?: ModelIDInput | null;
  extractedResults?: ModelStringInput | null;
  missingFields?: ModelStringInput | null;
  executionTime?: ModelFloatInput | null;
  status?: ModelScanStatusInput | null;
  originalScanResults?: ModelStringInput | null;
  extractedProductsResults?: ModelStringInput | null;
  isScanIncludedProducts?: ModelTFInput | null;
  and?: Array<ModelInvoiceScanTaskConditionInput | null> | null;
  or?: Array<ModelInvoiceScanTaskConditionInput | null> | null;
  not?: ModelInvoiceScanTaskConditionInput | null;
};

export type UpdateInvoiceScanTaskInput = {
  id: string;
  invoiceID?: string | null;
  folderScanTaskID?: string | null;
  folderID?: string | null;
  createdByID?: string | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
};

export type DeleteInvoiceScanTaskInput = {
  id: string;
};

export type CreateCodebookInput = {
  id?: string | null;
  companyName: string;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code: string;
  vatNumber?: string | null;
  clientID: string;
};

export type ModelCodebookConditionInput = {
  companyName?: ModelStringInput | null;
  searchKeyword?: ModelStringInput | null;
  idNumber?: ModelStringInput | null;
  code?: ModelStringInput | null;
  vatNumber?: ModelStringInput | null;
  clientID?: ModelIDInput | null;
  and?: Array<ModelCodebookConditionInput | null> | null;
  or?: Array<ModelCodebookConditionInput | null> | null;
  not?: ModelCodebookConditionInput | null;
};

export type Codebook = {
  __typename: "Codebook";
  id: string;
  companyName: string;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code: string;
  vatNumber?: string | null;
  clientID: string;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCodebookInput = {
  id: string;
  companyName?: string | null;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code?: string | null;
  vatNumber?: string | null;
  clientID?: string | null;
};

export type DeleteCodebookInput = {
  id: string;
};

export type CreateTemplateInput = {
  id?: string | null;
  name: string;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template: string;
  productsEnabled?: TF | null;
  isFixedValueEnabled: String | null;
  fixedValues: String | null;
};

export type ModelTemplateConditionInput = {
  name?: ModelStringInput | null;
  searchKeyword?: ModelStringInput | null;
  description?: ModelStringInput | null;
  clientID?: ModelIDInput | null;
  template?: ModelStringInput | null;
  productsEnabled?: ModelTFInput | null;
  clientIDProductsEnabledPK?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelTemplateConditionInput | null> | null;
  or?: Array<ModelTemplateConditionInput | null> | null;
  not?: ModelTemplateConditionInput | null;
};

export type Template = {
  __typename: "Template";
  id: string;
  name: string;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template: string;
  productsEnabled?: TF | null;
  clientIDProductsEnabledPK?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateTemplateInput = {
  id: string;
  name?: string | null;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template?: string | null;
  productsEnabled?: TF | null;
  clientIDProductsEnabledPK?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type DeleteTemplateInput = {
  id: string;
};

export type CreateSystemConfigurationInput = {
  id?: string | null;
  value: string;
  type: string;
  note?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ModelSystemConfigurationConditionInput = {
  value?: ModelStringInput | null;
  type?: ModelStringInput | null;
  note?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelSystemConfigurationConditionInput | null> | null;
  or?: Array<ModelSystemConfigurationConditionInput | null> | null;
  not?: ModelSystemConfigurationConditionInput | null;
};

export type SystemConfiguration = {
  __typename: "SystemConfiguration";
  id: string;
  value: string;
  type: string;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSystemConfigurationInput = {
  id: string;
  value?: string | null;
  type?: string | null;
  note?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type DeleteSystemConfigurationInput = {
  id: string;
};

export type CreateWorkerInput = {
  id?: string | null;
  name: string;
  status: WorkerStatus;
};

export type ModelWorkerConditionInput = {
  name?: ModelStringInput | null;
  status?: ModelWorkerStatusInput | null;
  and?: Array<ModelWorkerConditionInput | null> | null;
  or?: Array<ModelWorkerConditionInput | null> | null;
  not?: ModelWorkerConditionInput | null;
};

export type ModelWorkerStatusInput = {
  eq?: WorkerStatus | null;
  ne?: WorkerStatus | null;
};

export type UpdateWorkerInput = {
  id: string;
  name?: string | null;
  status?: WorkerStatus | null;
};

export type DeleteWorkerInput = {
  id: string;
};

export type UpdateMapperConfigurationInput = {
  id: string;
  clientID?: string | null;
  type?: MapConfigurationType | null;
  configuration?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ModelMapperConfigurationConditionInput = {
  clientID?: ModelIDInput | null;
  type?: ModelMapConfigurationTypeInput | null;
  configuration?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelMapperConfigurationConditionInput | null> | null;
  or?: Array<ModelMapperConfigurationConditionInput | null> | null;
  not?: ModelMapperConfigurationConditionInput | null;
};

export type ModelMapConfigurationTypeInput = {
  eq?: MapConfigurationType | null;
  ne?: MapConfigurationType | null;
};

export type DeleteMapperConfigurationInput = {
  id: string;
};

export type CreateFiaReportJobInput = {
  id?: string | null;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<SelectedColumnInput | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  exportedFileUrl?: string | null;
  missingKeys?: MissingKeysInput | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type SelectedColumnInput = {
  fieldType: FiaReportFieldType;
  index?: number | null;
  columnName?: string | null;
};

export type MissingKeysInput = {
  keys?: string | null;
  dismissed?: number | null;
};

export type ModelFiaReportJobConditionInput = {
  token?: ModelStringInput | null;
  userID?: ModelIDInput | null;
  status?: ModelFiaReportJobStatusInput | null;
  userIDStatusPK?: ModelStringInput | null;
  spreadSheetUrl?: ModelStringInput | null;
  proxySheetUrl?: ModelStringInput | null;
  sourceType?: ModelFiaReportSourceTypeInput | null;
  source?: ModelStringInput | null;
  sourcePdf?: ModelStringInput | null;
  sourceDisplay?: ModelStringInput | null;
  errorMessage?: ModelStringInput | null;
  tableColumns?: ModelStringInput | null;
  skipColumnSelection?: ModelBooleanInput | null;
  tablesJsonUrl?: ModelStringInput | null;
  previousSpreadsheetUrl?: ModelStringInput | null;
  permissionToEmail?: ModelStringInput | null;
  exportedFileUrl?: ModelStringInput | null;
  companyName?: ModelStringInput | null;
  thumbnailUrls?: ModelStringInput | null;
  downloaded?: ModelTFInput | null;
  downloadedUserIDPK?: ModelStringInput | null;
  companyType?: ModelCompanyTypeInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelFiaReportJobConditionInput | null> | null;
  or?: Array<ModelFiaReportJobConditionInput | null> | null;
  not?: ModelFiaReportJobConditionInput | null;
};

export type ModelFiaReportJobStatusInput = {
  eq?: FiaReportJobStatus | null;
  ne?: FiaReportJobStatus | null;
};

export type ModelFiaReportSourceTypeInput = {
  eq?: FiaReportSourceType | null;
  ne?: FiaReportSourceType | null;
};

export type ModelCompanyTypeInput = {
  eq?: CompanyType | null;
  ne?: CompanyType | null;
};

export type UpdateFiaReportJobInput = {
  id: string;
  token?: string | null;
  userID?: string | null;
  status?: FiaReportJobStatus | null;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<SelectedColumnInput | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  exportedFileUrl?: string | null;
  missingKeys?: MissingKeysInput | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type DeleteFiaReportJobInput = {
  id: string;
};

export type SearchableAllSortInput = {
  field?: SearchableFolderSortableFields | null;
  direction?: SearchableSortDirection | null;
};

export enum SearchableFolderSortableFields {
  id = "id",
  name = "name",
  searchKeyword = "searchKeyword",
  clientID = "clientID",
  downloadLink = "downloadLink",
  latestFolderInvoiceTaskID = "latestFolderInvoiceTaskID",
  areThereMissingFields = "areThereMissingFields",
  invoicesCount = "invoicesCount",
  latestCompletedAt = "latestCompletedAt",
  createdAt = "createdAt",
  updatedAt = "updatedAt"
}

export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc"
}

export type SearchAllOutput = {
  __typename: "SearchAllOutput";
  folders?: Array<Folder | null> | null;
  invoices?: Array<Invoice | null> | null;
  nextToken?: string | null;
};

export type ModelExportFolderInvoicesInput = {
  folderID: string;
  templateID: string;
  format: string;
  vatIncludedInvoiceIDs?: Array<string | null> | null;
  startingIndex?: number | null;
};

export type ModelExportFolderInvoicesOutput = {
  __typename: "ModelExportFolderInvoicesOutput";
  output?: ModelExportFolderInvoicesDataOutput | null;
};

export type ModelExportFolderInvoicesDataOutput = {
  __typename: "ModelExportFolderInvoicesDataOutput";
  fileName?: string | null;
  mimeType?: string | null;
  fileContent?: string | null;
};

export type ModelGetStatisticsOutput = {
  __typename: "ModelGetStatisticsOutput";
  scans?: string | null;
  clients?: string | null;
};

export type ExportFolderFromNanoInput = {
  folderID?: string | null;
};

export type ExportFolderFromNanoOutput = {
  __typename: "ExportFolderFromNanoOutput";
  csvFileUrl?: string | null;
  xlsxFileUrl?: string | null;
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null;
  username?: ModelStringInput | null;
  email?: ModelStringInput | null;
  firstName?: ModelStringInput | null;
  lastName?: ModelStringInput | null;
  company?: ModelStringInput | null;
  phone?: ModelStringInput | null;
  address?: ModelStringInput | null;
  status?: ModelClientStatusInput | null;
  type?: ModelUserTypeInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelUserFilterInput | null> | null;
  or?: Array<ModelUserFilterInput | null> | null;
  not?: ModelUserFilterInput | null;
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection";
  items: Array<User | null>;
  nextToken?: string | null;
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC"
}

export type ModelClientFilterInput = {
  id?: ModelIDInput | null;
  username?: ModelStringInput | null;
  email?: ModelStringInput | null;
  firstName?: ModelStringInput | null;
  lastName?: ModelStringInput | null;
  company?: ModelStringInput | null;
  phone?: ModelStringInput | null;
  address?: ModelStringInput | null;
  city?: ModelStringInput | null;
  totalScanCount?: ModelIntInput | null;
  expirationDate?: ModelStringInput | null;
  isVatIncluded?: ModelTFInput | null;
  status?: ModelClientStatusInput | null;
  userID?: ModelIDInput | null;
  viberID?: ModelStringInput | null;
  totalFiaReportProcessCount?: ModelIntInput | null;
  fiaAccessStatus?: ModelClientFiaAccessStatusInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  downloadQuota?: ModelIntInput | null;
  reportQuota?: ModelIntInput | null;
  downloadedCount?: ModelIntInput | null;
  and?: Array<ModelClientFilterInput | null> | null;
  or?: Array<ModelClientFilterInput | null> | null;
  not?: ModelClientFilterInput | null;
};

export type ModelClientFiaAccessStatusInput = {
  eq?: ClientFiaAccessStatus | null;
  ne?: ClientFiaAccessStatus | null;
};

export type ModelClientConnection = {
  __typename: "ModelClientConnection";
  items: Array<Client>;
  nextToken?: string | null;
  scannedCount?: string | null;
};

export type ModelFolderFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  searchKeyword?: ModelStringInput | null;
  clientID?: ModelIDInput | null;
  downloadLink?: ModelStringInput | null;
  status?: ModelScanStatusInput | null;
  latestFolderInvoiceTaskID?: ModelIDInput | null;
  areThereMissingFields?: ModelBooleanInput | null;
  invoicesCount?: ModelIntInput | null;
  exportStatus?: ModelFolderExportStatusInput | null;
  latestCompletedAt?: ModelStringInput | null;
  isLatestScanIncludedProducts?: ModelTFInput | null;
  parentFolderID?: ModelIDInput | null;
  clientIDParentFolderIDPK?: ModelStringInput | null;
  isDeleted?: ModelBooleanInput | null;
  and?: Array<ModelFolderFilterInput | null> | null;
  or?: Array<ModelFolderFilterInput | null> | null;
  not?: ModelFolderFilterInput | null;
};

export type ModelFolderExportStatusInput = {
  eq?: FolderExportStatus | null;
  ne?: FolderExportStatus | null;
};

export type SearchableFolderFilterInput = {
  id?: SearchableIDFilterInput | null;
  name?: SearchableStringFilterInput | null;
  searchKeyword?: SearchableStringFilterInput | null;
  clientID?: SearchableIDFilterInput | null;
  downloadLink?: SearchableStringFilterInput | null;
  latestFolderInvoiceTaskID?: SearchableIDFilterInput | null;
  areThereMissingFields?: SearchableBooleanFilterInput | null;
  invoicesCount?: SearchableIntFilterInput | null;
  latestCompletedAt?: SearchableStringFilterInput | null;
  parentFolderID?: SearchableIDFilterInput | null;
  clientIDParentFolderIDPK?: SearchableStringFilterInput | null;
  isDeleted?: SearchableBooleanFilterInput | null;
  createdAt?: SearchableStringFilterInput | null;
  updatedAt?: SearchableStringFilterInput | null;
  status?: SearchableStringFilterInput | null;
  exportStatus?: SearchableStringFilterInput | null;
  isLatestScanIncludedProducts?: SearchableStringFilterInput | null;
  and?: Array<SearchableFolderFilterInput | null> | null;
  or?: Array<SearchableFolderFilterInput | null> | null;
  not?: SearchableFolderFilterInput | null;
};

export type SearchableIDFilterInput = {
  ne?: string | null;
  gt?: string | null;
  lt?: string | null;
  gte?: string | null;
  lte?: string | null;
  eq?: string | null;
  match?: string | null;
  matchPhrase?: string | null;
  matchPhrasePrefix?: string | null;
  multiMatch?: string | null;
  exists?: boolean | null;
  wildcard?: string | null;
  regexp?: string | null;
  range?: Array<string | null> | null;
};

export type SearchableStringFilterInput = {
  ne?: string | null;
  gt?: string | null;
  lt?: string | null;
  gte?: string | null;
  lte?: string | null;
  eq?: string | null;
  match?: string | null;
  matchPhrase?: string | null;
  matchPhrasePrefix?: string | null;
  multiMatch?: string | null;
  exists?: boolean | null;
  wildcard?: string | null;
  regexp?: string | null;
  range?: Array<string | null> | null;
};

export type SearchableBooleanFilterInput = {
  eq?: boolean | null;
  ne?: boolean | null;
};

export type SearchableIntFilterInput = {
  ne?: number | null;
  gt?: number | null;
  lt?: number | null;
  gte?: number | null;
  lte?: number | null;
  eq?: number | null;
  range?: Array<number | null> | null;
};

export type SearchableFolderSortInput = {
  field?: SearchableFolderSortableFields | null;
  direction?: SearchableSortDirection | null;
};

export type SearchableFolderAggregationInput = {
  name: string;
  type: SearchableAggregateType;
  field: SearchableFolderAggregateField;
};

export enum SearchableAggregateType {
  terms = "terms",
  avg = "avg",
  min = "min",
  max = "max",
  sum = "sum"
}

export enum SearchableFolderAggregateField {
  id = "id",
  name = "name",
  searchKeyword = "searchKeyword",
  clientID = "clientID",
  downloadLink = "downloadLink",
  status = "status",
  latestFolderInvoiceTaskID = "latestFolderInvoiceTaskID",
  areThereMissingFields = "areThereMissingFields",
  invoicesCount = "invoicesCount",
  exportStatus = "exportStatus",
  latestCompletedAt = "latestCompletedAt",
  isLatestScanIncludedProducts = "isLatestScanIncludedProducts",
  parentFolderID = "parentFolderID",
  clientIDParentFolderIDPK = "clientIDParentFolderIDPK",
  isDeleted = "isDeleted",
  createdAt = "createdAt",
  updatedAt = "updatedAt"
}

export type SearchableFolderConnection = {
  __typename: "SearchableFolderConnection";
  items: Array<Folder | null>;
  nextToken?: string | null;
  total?: number | null;
  aggregateItems: Array<SearchableAggregateResult | null>;
};

export type SearchableAggregateResult = {
  __typename: "SearchableAggregateResult";
  name: string;
  result?: SearchableAggregateGenericResult | null;
};

export type SearchableAggregateGenericResult =
  | SearchableAggregateScalarResult
  | SearchableAggregateBucketResult;

export type SearchableAggregateScalarResult = {
  __typename: "SearchableAggregateScalarResult";
  value: number;
};

export type SearchableAggregateBucketResult = {
  __typename: "SearchableAggregateBucketResult";
  buckets?: Array<SearchableAggregateBucketResultItem | null> | null;
};

export type SearchableAggregateBucketResultItem = {
  __typename: "SearchableAggregateBucketResultItem";
  key: string;
  doc_count: number;
};

export type ModelInvoiceFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  folderID?: ModelIDInput | null;
  folderIDIsDeletedPK?: ModelIDInput | null;
  clientID?: ModelIDInput | null;
  extractedResults?: ModelStringInput | null;
  missingFields?: ModelStringInput | null;
  thumbnailPath?: ModelStringInput | null;
  index?: ModelFloatInput | null;
  extractedProductsResults?: ModelStringInput | null;
  isLatestScanIncludedProducts?: ModelTFInput | null;
  rotateAngle?: ModelIntInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  nanonetsID?: ModelStringInput | null;
  title?: ModelStringInput | null;
  searchToken?: ModelStringInput | null;
  isDeleted?: ModelBooleanInput | null;
  and?: Array<ModelInvoiceFilterInput | null> | null;
  or?: Array<ModelInvoiceFilterInput | null> | null;
  not?: ModelInvoiceFilterInput | null;
};

export type ModelFloatKeyConditionInput = {
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type SearchableInvoiceFilterInput = {
  id?: SearchableIDFilterInput | null;
  name?: SearchableStringFilterInput | null;
  folderID?: SearchableIDFilterInput | null;
  folderIDIsDeletedPK?: SearchableIDFilterInput | null;
  clientID?: SearchableIDFilterInput | null;
  extractedResults?: SearchableStringFilterInput | null;
  missingFields?: SearchableStringFilterInput | null;
  thumbnailPath?: SearchableStringFilterInput | null;
  index?: SearchableFloatFilterInput | null;
  extractedProductsResults?: SearchableStringFilterInput | null;
  rotateAngle?: SearchableIntFilterInput | null;
  createdAt?: SearchableStringFilterInput | null;
  updatedAt?: SearchableStringFilterInput | null;
  nanonetsID?: SearchableStringFilterInput | null;
  title?: SearchableStringFilterInput | null;
  searchToken?: SearchableStringFilterInput | null;
  isDeleted?: SearchableBooleanFilterInput | null;
  isLatestScanIncludedProducts?: SearchableStringFilterInput | null;
  and?: Array<SearchableInvoiceFilterInput | null> | null;
  or?: Array<SearchableInvoiceFilterInput | null> | null;
  not?: SearchableInvoiceFilterInput | null;
};

export type SearchableFloatFilterInput = {
  ne?: number | null;
  gt?: number | null;
  lt?: number | null;
  gte?: number | null;
  lte?: number | null;
  eq?: number | null;
  range?: Array<number | null> | null;
};

export type SearchableInvoiceSortInput = {
  field?: SearchableInvoiceSortableFields | null;
  direction?: SearchableSortDirection | null;
};

export enum SearchableInvoiceSortableFields {
  id = "id",
  name = "name",
  folderID = "folderID",
  folderIDIsDeletedPK = "folderIDIsDeletedPK",
  clientID = "clientID",
  extractedResults = "extractedResults",
  missingFields = "missingFields",
  thumbnailPath = "thumbnailPath",
  index = "index",
  extractedProductsResults = "extractedProductsResults",
  rotateAngle = "rotateAngle",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  nanonetsID = "nanonetsID",
  title = "title",
  searchToken = "searchToken",
  isDeleted = "isDeleted"
}

export type SearchableInvoiceAggregationInput = {
  name: string;
  type: SearchableAggregateType;
  field: SearchableInvoiceAggregateField;
};

export enum SearchableInvoiceAggregateField {
  id = "id",
  name = "name",
  folderID = "folderID",
  folderIDIsDeletedPK = "folderIDIsDeletedPK",
  clientID = "clientID",
  extractedResults = "extractedResults",
  missingFields = "missingFields",
  thumbnailPath = "thumbnailPath",
  index = "index",
  extractedProductsResults = "extractedProductsResults",
  isLatestScanIncludedProducts = "isLatestScanIncludedProducts",
  rotateAngle = "rotateAngle",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  nanonetsID = "nanonetsID",
  title = "title",
  searchToken = "searchToken",
  isDeleted = "isDeleted"
}

export type SearchableInvoiceConnection = {
  __typename: "SearchableInvoiceConnection";
  items: Array<Invoice | null>;
  nextToken?: string | null;
  total?: number | null;
  aggregateItems: Array<SearchableAggregateResult | null>;
};

export type ModelInvoiceUserAssignmentFilterInput = {
  id?: ModelIDInput | null;
  invoiceID?: ModelIDInput | null;
  clientID?: ModelIDInput | null;
  email?: ModelStringInput | null;
  role?: ModelStringInput | null;
  notified?: ModelTFInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelInvoiceUserAssignmentFilterInput | null> | null;
  or?: Array<ModelInvoiceUserAssignmentFilterInput | null> | null;
  not?: ModelInvoiceUserAssignmentFilterInput | null;
};

export type ModelStringKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export type ModelFolderScanTaskFilterInput = {
  id?: ModelIDInput | null;
  folderID?: ModelIDInput | null;
  clientID?: ModelIDInput | null;
  taskCount?: ModelIntInput | null;
  processedTaskCount?: ModelIntInput | null;
  failedTaskCount?: ModelIntInput | null;
  executionTime?: ModelFloatInput | null;
  logMessages?: ModelStringInput | null;
  status?: ModelScanStatusInput | null;
  extractedResults?: ModelStringInput | null;
  missingFieldsCount?: ModelIntInput | null;
  isScanIncludedProducts?: ModelTFInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelFolderScanTaskFilterInput | null> | null;
  or?: Array<ModelFolderScanTaskFilterInput | null> | null;
  not?: ModelFolderScanTaskFilterInput | null;
};

export type ModelInvoiceScanTaskFilterInput = {
  id?: ModelIDInput | null;
  invoiceID?: ModelIDInput | null;
  folderScanTaskID?: ModelIDInput | null;
  folderID?: ModelIDInput | null;
  createdByID?: ModelIDInput | null;
  logMessages?: ModelStringInput | null;
  queueID?: ModelStringInput | null;
  workerID?: ModelIDInput | null;
  extractedResults?: ModelStringInput | null;
  missingFields?: ModelStringInput | null;
  executionTime?: ModelFloatInput | null;
  status?: ModelScanStatusInput | null;
  originalScanResults?: ModelStringInput | null;
  extractedProductsResults?: ModelStringInput | null;
  isScanIncludedProducts?: ModelTFInput | null;
  and?: Array<ModelInvoiceScanTaskFilterInput | null> | null;
  or?: Array<ModelInvoiceScanTaskFilterInput | null> | null;
  not?: ModelInvoiceScanTaskFilterInput | null;
};

export type ModelCodebookFilterInput = {
  id?: ModelIDInput | null;
  companyName?: ModelStringInput | null;
  searchKeyword?: ModelStringInput | null;
  idNumber?: ModelStringInput | null;
  code?: ModelStringInput | null;
  vatNumber?: ModelStringInput | null;
  clientID?: ModelIDInput | null;
  and?: Array<ModelCodebookFilterInput | null> | null;
  or?: Array<ModelCodebookFilterInput | null> | null;
  not?: ModelCodebookFilterInput | null;
};

export type ModelCodebookConnection = {
  __typename: "ModelCodebookConnection";
  items: Array<Codebook | null>;
  nextToken?: string | null;
};

export type ModelTemplateFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  searchKeyword?: ModelStringInput | null;
  description?: ModelStringInput | null;
  clientID?: ModelIDInput | null;
  template?: ModelStringInput | null;
  productsEnabled?: ModelTFInput | null;
  clientIDProductsEnabledPK?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelTemplateFilterInput | null> | null;
  or?: Array<ModelTemplateFilterInput | null> | null;
  not?: ModelTemplateFilterInput | null;
};

export type ModelTemplateConnection = {
  __typename: "ModelTemplateConnection";
  items: Array<Template | null>;
  nextToken?: string | null;
};

export type ModelSystemConfigurationFilterInput = {
  id?: ModelIDInput | null;
  value?: ModelStringInput | null;
  type?: ModelStringInput | null;
  note?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelSystemConfigurationFilterInput | null> | null;
  or?: Array<ModelSystemConfigurationFilterInput | null> | null;
  not?: ModelSystemConfigurationFilterInput | null;
};

export type ModelSystemConfigurationConnection = {
  __typename: "ModelSystemConfigurationConnection";
  items: Array<SystemConfiguration | null>;
  nextToken?: string | null;
};

export type ModelWorkerFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  status?: ModelWorkerStatusInput | null;
  and?: Array<ModelWorkerFilterInput | null> | null;
  or?: Array<ModelWorkerFilterInput | null> | null;
  not?: ModelWorkerFilterInput | null;
};

export type ModelWorkerConnection = {
  __typename: "ModelWorkerConnection";
  items: Array<Worker | null>;
  nextToken?: string | null;
};

export type ModelMapperConfigurationFilterInput = {
  id?: ModelIDInput | null;
  clientID?: ModelIDInput | null;
  type?: ModelMapConfigurationTypeInput | null;
  configuration?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelMapperConfigurationFilterInput | null> | null;
  or?: Array<ModelMapperConfigurationFilterInput | null> | null;
  not?: ModelMapperConfigurationFilterInput | null;
};

export type ModelMapperConfigurationConnection = {
  __typename: "ModelMapperConfigurationConnection";
  items: Array<MapperConfiguration | null>;
  nextToken?: string | null;
};

export type ModelFiaReportJobFilterInput = {
  id?: ModelIDInput | null;
  token?: ModelStringInput | null;
  userID?: ModelIDInput | null;
  status?: ModelFiaReportJobStatusInput | null;
  userIDStatusPK?: ModelStringInput | null;
  spreadSheetUrl?: ModelStringInput | null;
  sourceType?: ModelFiaReportSourceTypeInput | null;
  source?: ModelStringInput | null;
  sourceDisplay?: ModelStringInput | null;
  errorMessage?: ModelStringInput | null;
  tableColumns?: ModelStringInput | null;
  skipColumnSelection?: ModelBooleanInput | null;
  tablesJsonUrl?: ModelStringInput | null;
  previousSpreadsheetUrl?: ModelStringInput | null;
  permissionToEmail?: ModelStringInput | null;
  companyName?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelFiaReportJobFilterInput | null> | null;
  or?: Array<ModelFiaReportJobFilterInput | null> | null;
  not?: ModelFiaReportJobFilterInput | null;
};

export type ModelFiaReportJobConnection = {
  __typename: "ModelFiaReportJobConnection";
  items: Array<FiaReportJob | null>;
  nextToken?: string | null;
};

export type ModelSubscriptionInvoiceFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  folderID?: ModelSubscriptionIDInput | null;
  extractedResults?: ModelSubscriptionStringInput | null;
  missingFields?: ModelSubscriptionStringInput | null;
  thumbnailPath?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionInvoiceFilterInput | null> | null;
  or?: Array<ModelSubscriptionInvoiceFilterInput | null> | null;
};

export type ModelSubscriptionIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  username?: ModelSubscriptionStringInput | null;
  email?: ModelSubscriptionStringInput | null;
  firstName?: ModelSubscriptionStringInput | null;
  lastName?: ModelSubscriptionStringInput | null;
  company?: ModelSubscriptionStringInput | null;
  phone?: ModelSubscriptionStringInput | null;
  address?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  type?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionUserFilterInput | null> | null;
  or?: Array<ModelSubscriptionUserFilterInput | null> | null;
};

export type ModelSubscriptionClientFilterInput = {
  username?: ModelSubscriptionStringInput | null;
  email?: ModelSubscriptionStringInput | null;
  firstName?: ModelSubscriptionStringInput | null;
  lastName?: ModelSubscriptionStringInput | null;
  company?: ModelSubscriptionStringInput | null;
  phone?: ModelSubscriptionStringInput | null;
  address?: ModelSubscriptionStringInput | null;
  city?: ModelSubscriptionStringInput | null;
  totalScanCount?: ModelSubscriptionIntInput | null;
  expirationDate?: ModelSubscriptionStringInput | null;
  isVatIncluded?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  userID?: ModelSubscriptionIDInput | null;
  viberID?: ModelSubscriptionStringInput | null;
  totalFiaReportProcessCount?: ModelSubscriptionIntInput | null;
  fiaAccessStatus?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  downloadQuota?: ModelSubscriptionIntInput | null;
  reportQuota?: ModelSubscriptionIntInput | null;
  downloadedCount?: ModelSubscriptionIntInput | null;
  and?: Array<ModelSubscriptionClientFilterInput | null> | null;
  or?: Array<ModelSubscriptionClientFilterInput | null> | null;
};

export type ModelSubscriptionIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionFolderFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  searchKeyword?: ModelSubscriptionStringInput | null;
  downloadLink?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  latestFolderInvoiceTaskID?: ModelSubscriptionIDInput | null;
  areThereMissingFields?: ModelSubscriptionBooleanInput | null;
  invoicesCount?: ModelSubscriptionIntInput | null;
  exportStatus?: ModelSubscriptionStringInput | null;
  latestCompletedAt?: ModelSubscriptionStringInput | null;
  isLatestScanIncludedProducts?: ModelSubscriptionStringInput | null;
  parentFolderID?: ModelSubscriptionIDInput | null;
  clientIDParentFolderIDPK?: ModelSubscriptionStringInput | null;
  isDeleted?: ModelSubscriptionBooleanInput | null;
  and?: Array<ModelSubscriptionFolderFilterInput | null> | null;
  or?: Array<ModelSubscriptionFolderFilterInput | null> | null;
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
};

export type ModelSubscriptionInvoiceUserAssignmentFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  invoiceID?: ModelSubscriptionIDInput | null;
  email?: ModelSubscriptionStringInput | null;
  role?: ModelSubscriptionStringInput | null;
  notified?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionInvoiceUserAssignmentFilterInput | null> | null;
  or?: Array<ModelSubscriptionInvoiceUserAssignmentFilterInput | null> | null;
};

export type ModelSubscriptionFolderScanTaskFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  folderID?: ModelSubscriptionIDInput | null;
  taskCount?: ModelSubscriptionIntInput | null;
  processedTaskCount?: ModelSubscriptionIntInput | null;
  failedTaskCount?: ModelSubscriptionIntInput | null;
  executionTime?: ModelSubscriptionFloatInput | null;
  logMessages?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  extractedResults?: ModelSubscriptionStringInput | null;
  missingFieldsCount?: ModelSubscriptionIntInput | null;
  isScanIncludedProducts?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionFolderScanTaskFilterInput | null> | null;
  or?: Array<ModelSubscriptionFolderScanTaskFilterInput | null> | null;
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionInvoiceScanTaskFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  invoiceID?: ModelSubscriptionIDInput | null;
  folderScanTaskID?: ModelSubscriptionIDInput | null;
  folderID?: ModelSubscriptionIDInput | null;
  logMessages?: ModelSubscriptionStringInput | null;
  queueID?: ModelSubscriptionStringInput | null;
  workerID?: ModelSubscriptionIDInput | null;
  extractedResults?: ModelSubscriptionStringInput | null;
  missingFields?: ModelSubscriptionStringInput | null;
  executionTime?: ModelSubscriptionFloatInput | null;
  status?: ModelSubscriptionStringInput | null;
  originalScanResults?: ModelSubscriptionStringInput | null;
  extractedProductsResults?: ModelSubscriptionStringInput | null;
  isScanIncludedProducts?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionInvoiceScanTaskFilterInput | null> | null;
  or?: Array<ModelSubscriptionInvoiceScanTaskFilterInput | null> | null;
};

export type ModelSubscriptionCodebookFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  companyName?: ModelSubscriptionStringInput | null;
  searchKeyword?: ModelSubscriptionStringInput | null;
  idNumber?: ModelSubscriptionStringInput | null;
  code?: ModelSubscriptionStringInput | null;
  vatNumber?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionCodebookFilterInput | null> | null;
  or?: Array<ModelSubscriptionCodebookFilterInput | null> | null;
};

export type ModelSubscriptionTemplateFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  searchKeyword?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  clientID?: ModelSubscriptionIDInput | null;
  template?: ModelSubscriptionStringInput | null;
  productsEnabled?: ModelSubscriptionStringInput | null;
  clientIDProductsEnabledPK?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionTemplateFilterInput | null> | null;
  or?: Array<ModelSubscriptionTemplateFilterInput | null> | null;
};

export type ModelSubscriptionSystemConfigurationFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  value?: ModelSubscriptionStringInput | null;
  type?: ModelSubscriptionStringInput | null;
  note?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionSystemConfigurationFilterInput | null> | null;
  or?: Array<ModelSubscriptionSystemConfigurationFilterInput | null> | null;
};

export type ModelSubscriptionWorkerFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionWorkerFilterInput | null> | null;
  or?: Array<ModelSubscriptionWorkerFilterInput | null> | null;
};

export type ModelSubscriptionMapperConfigurationFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  type?: ModelSubscriptionStringInput | null;
  configuration?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionMapperConfigurationFilterInput | null> | null;
  or?: Array<ModelSubscriptionMapperConfigurationFilterInput | null> | null;
};

export type ModelSubscriptionFiaReportJobFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  token?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  userIDStatusPK?: ModelSubscriptionStringInput | null;
  spreadSheetUrl?: ModelSubscriptionStringInput | null;
  proxySheetUrl?: ModelSubscriptionStringInput | null;
  sourceType?: ModelSubscriptionStringInput | null;
  source?: ModelSubscriptionStringInput | null;
  sourcePdf?: ModelSubscriptionStringInput | null;
  sourceDisplay?: ModelSubscriptionStringInput | null;
  errorMessage?: ModelSubscriptionStringInput | null;
  tableColumns?: ModelSubscriptionStringInput | null;
  skipColumnSelection?: ModelSubscriptionBooleanInput | null;
  tablesJsonUrl?: ModelSubscriptionStringInput | null;
  previousSpreadsheetUrl?: ModelSubscriptionStringInput | null;
  permissionToEmail?: ModelSubscriptionStringInput | null;
  exportedFileUrl?: ModelSubscriptionStringInput | null;
  companyName?: ModelSubscriptionStringInput | null;
  thumbnailUrls?: ModelSubscriptionStringInput | null;
  downloaded?: ModelSubscriptionStringInput | null;
  downloadedUserIDPK?: ModelSubscriptionStringInput | null;
  companyType?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionFiaReportJobFilterInput | null> | null;
  or?: Array<ModelSubscriptionFiaReportJobFilterInput | null> | null;
};

export type DownloadFiaReportMutation = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<{
    __typename: "SelectedColumn";
    fieldType: FiaReportFieldType;
    index?: number | null;
    columnName?: string | null;
  } | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  exportedFileUrl?: string | null;
  missingKeys?: {
    __typename: "MissingKeys";
    keys?: string | null;
    dismissed?: number | null;
  } | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateClientStatusMutation = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  folders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: {
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type GenerateFiaReportMutation = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<{
    __typename: "SelectedColumn";
    fieldType: FiaReportFieldType;
    index?: number | null;
    columnName?: string | null;
  } | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  exportedFileUrl?: string | null;
  missingKeys?: {
    __typename: "MissingKeys";
    keys?: string | null;
    dismissed?: number | null;
  } | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

export type CompleteFiaReportMutation = {
  __typename: "SqsStatus";
  statusCode?: number | null;
  body?: string | null;
  headers?: string | null;
};

export type ExportFiaReportMutation = {
  __typename: "SqsStatus";
  statusCode?: number | null;
  body?: string | null;
  headers?: string | null;
};

export type GeneratePreviewUrlMutation = {
  __typename: "Invoice";
  id: string;
  name: string;
  folderID: string;
  folderIDIsDeletedPK?: string | null;
  clientID: string;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  index: number;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  rotateAngle: number;
  invoiceUserAssignments?: {
    __typename: "ModelInvoiceUserAssignmentConnection";
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
  nanonets?: {
    __typename: "NanonetsInfo";
    previewUrl?: string | null;
    fileID?: string | null;
    modelID?: string | null;
    expiresAt?: number | null;
    redirectUrl?: string | null;
  } | null;
  nanonetsID?: string | null;
  title?: string | null;
  searchToken?: string | null;
  isDeleted?: boolean | null;
};

export type PredictFolderMutation = {
  __typename: "PredictFolderOutput";
  invoices?: Array<{
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null> | null;
};

export type PredictFolderAsyncMutation = {
  __typename: "SqsStatus";
  statusCode?: number | null;
  body?: string | null;
  headers?: string | null;
};

export type TestExceptionIdentityMutation = {
  __typename: "TestExceptionIdentityOutput";
  matchedIdentities: Array<{
    __typename: "Identity";
    key: string;
    value: string;
  } | null>;
};

export type IncrementClientCountersMutation = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  folders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: {
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type CreateClientMutation = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  folders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: {
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type CreateFolderScanTaskMutation = {
  __typename: "FolderScanTask";
  id: string;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  clientID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  taskCount?: number | null;
  processedTaskCount?: number | null;
  failedTaskCount?: number | null;
  executionTime?: number | null;
  logMessages?: string | null;
  status?: ScanStatus | null;
  extractedResults?: string | null;
  missingFieldsCount?: number | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type IncreaseProcessedTaskCountInFolderScanTaskMutation = {
  __typename: "FolderScanTask";
  id: string;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  clientID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  taskCount?: number | null;
  processedTaskCount?: number | null;
  failedTaskCount?: number | null;
  executionTime?: number | null;
  logMessages?: string | null;
  status?: ScanStatus | null;
  extractedResults?: string | null;
  missingFieldsCount?: number | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type IncreaseFailedTaskCountInFolderScanTaskMutation = {
  __typename: "FolderScanTask";
  id: string;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  clientID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  taskCount?: number | null;
  processedTaskCount?: number | null;
  failedTaskCount?: number | null;
  executionTime?: number | null;
  logMessages?: string | null;
  status?: ScanStatus | null;
  extractedResults?: string | null;
  missingFieldsCount?: number | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type AppendFolderScanTaskLogMessageMutation = {
  __typename: "FolderScanTask";
  id: string;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  clientID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  taskCount?: number | null;
  processedTaskCount?: number | null;
  failedTaskCount?: number | null;
  executionTime?: number | null;
  logMessages?: string | null;
  status?: ScanStatus | null;
  extractedResults?: string | null;
  missingFieldsCount?: number | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type CreatePresignedURLMutation = {
  __typename: "ModelCreatePresignedURLDataOutput";
  url?: string | null;
  filePath?: string | null;
  mimeType?: string | null;
};

export type CancelFolderScanTaskMutation = {
  __typename: "ModelCancelFolderScanTaskOutput";
  result?: string | null;
};

export type BulkCodebookImportMutation = {
  __typename: "ModelBulkCodebookImportOutput";
  result: string;
  message?: string | null;
};

export type BulkInvoiceDeleteMutation = {
  __typename: "ModelBulkInvoiceDeleteOutput";
  result: string;
  message?: string | null;
};

export type SendEmailMutation = {
  __typename: "ModelSendEmailOutput";
  result: string;
  message?: string | null;
};

export type ContactFormMutation = {
  __typename: "ModelContactFormOutput";
  result: string;
  message?: string | null;
};

export type CreateTrialUserMutation = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  folders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: {
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type CreateMapperConfigurationMutation = {
  __typename: "MapperConfiguration";
  id: string;
  clientID?: string | null;
  type: MapConfigurationType;
  configuration: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ResolveKeysMutation = {
  __typename: "HandleKeysOutput";
  success?: boolean | null;
};

export type CreateInvoiceMutation = {
  __typename: "Invoice";
  id: string;
  name: string;
  folderID: string;
  folderIDIsDeletedPK?: string | null;
  clientID: string;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  index: number;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  rotateAngle: number;
  invoiceUserAssignments?: {
    __typename: "ModelInvoiceUserAssignmentConnection";
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
  nanonets?: {
    __typename: "NanonetsInfo";
    previewUrl?: string | null;
    fileID?: string | null;
    modelID?: string | null;
    expiresAt?: number | null;
    redirectUrl?: string | null;
  } | null;
  nanonetsID?: string | null;
  title?: string | null;
  searchToken?: string | null;
  isDeleted?: boolean | null;
};

export type UpdateInvoiceMutation = {
  __typename: "Invoice";
  id: string;
  name: string;
  folderID: string;
  folderIDIsDeletedPK?: string | null;
  clientID: string;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  index: number;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  rotateAngle: number;
  invoiceUserAssignments?: {
    __typename: "ModelInvoiceUserAssignmentConnection";
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
  nanonets?: {
    __typename: "NanonetsInfo";
    previewUrl?: string | null;
    fileID?: string | null;
    modelID?: string | null;
    expiresAt?: number | null;
    redirectUrl?: string | null;
  } | null;
  nanonetsID?: string | null;
  title?: string | null;
  searchToken?: string | null;
  isDeleted?: boolean | null;
};

export type DeleteFolderMutation = {
  __typename: "Folder";
  id: string;
  name: string;
  searchKeyword?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  invoices?: {
    __typename: "ModelInvoiceConnection";
    nextToken?: string | null;
  } | null;
  latestFolderInvoiceTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  exportStatus?: FolderExportStatus | null;
  latestCompletedAt?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  parentFolderID?: string | null;
  parentFolder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  childFolders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  clientIDParentFolderIDPK?: string | null;
  isDeleted?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteClientMutation = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  folders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: {
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type DeleteInvoiceMutation = {
  __typename: "Invoice";
  id: string;
  name: string;
  folderID: string;
  folderIDIsDeletedPK?: string | null;
  clientID: string;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  index: number;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  rotateAngle: number;
  invoiceUserAssignments?: {
    __typename: "ModelInvoiceUserAssignmentConnection";
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
  nanonets?: {
    __typename: "NanonetsInfo";
    previewUrl?: string | null;
    fileID?: string | null;
    modelID?: string | null;
    expiresAt?: number | null;
    redirectUrl?: string | null;
  } | null;
  nanonetsID?: string | null;
  title?: string | null;
  searchToken?: string | null;
  isDeleted?: boolean | null;
};

export type BulkDeleteServiceMutation = {
  __typename: "BulkDeleteServiceOutput";
  success?: boolean | null;
  message?: string | null;
};

export type CreateUserMutation = {
  __typename: "User";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  status?: ClientStatus | null;
  type: UserType;
  createdAt: string;
  updatedAt: string;
};

export type AuthenticateViberIDMutation = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  folders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: {
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type UpdateInvoiceOrderMutation = {
  __typename: "QueueMessageResponse";
  success?: string | null;
};

export type CreateInvoiceUserAssignmentMutation = {
  __typename: "InvoiceUserAssignment";
  id: string;
  invoiceID: string;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  clientID: string;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  email: string;
  role?: string | null;
  notified: TF;
  createdAt: string;
  updatedAt: string;
};

export type DeleteInvoiceUserAssignmentMutation = {
  __typename: "InvoiceUserAssignment";
  id: string;
  invoiceID: string;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  clientID: string;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  email: string;
  role?: string | null;
  notified: TF;
  createdAt: string;
  updatedAt: string;
};

export type UpdateUserMutation = {
  __typename: "User";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  status?: ClientStatus | null;
  type: UserType;
  createdAt: string;
  updatedAt: string;
};

export type DeleteUserMutation = {
  __typename: "User";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  status?: ClientStatus | null;
  type: UserType;
  createdAt: string;
  updatedAt: string;
};

export type UpdateClientMutation = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  folders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: {
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type CreateFolderMutation = {
  __typename: "Folder";
  id: string;
  name: string;
  searchKeyword?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  invoices?: {
    __typename: "ModelInvoiceConnection";
    nextToken?: string | null;
  } | null;
  latestFolderInvoiceTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  exportStatus?: FolderExportStatus | null;
  latestCompletedAt?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  parentFolderID?: string | null;
  parentFolder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  childFolders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  clientIDParentFolderIDPK?: string | null;
  isDeleted?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateFolderMutation = {
  __typename: "Folder";
  id: string;
  name: string;
  searchKeyword?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  invoices?: {
    __typename: "ModelInvoiceConnection";
    nextToken?: string | null;
  } | null;
  latestFolderInvoiceTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  exportStatus?: FolderExportStatus | null;
  latestCompletedAt?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  parentFolderID?: string | null;
  parentFolder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  childFolders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  clientIDParentFolderIDPK?: string | null;
  isDeleted?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateInvoiceUserAssignmentMutation = {
  __typename: "InvoiceUserAssignment";
  id: string;
  invoiceID: string;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  clientID: string;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  email: string;
  role?: string | null;
  notified: TF;
  createdAt: string;
  updatedAt: string;
};

export type UpdateFolderScanTaskMutation = {
  __typename: "FolderScanTask";
  id: string;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  clientID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  taskCount?: number | null;
  processedTaskCount?: number | null;
  failedTaskCount?: number | null;
  executionTime?: number | null;
  logMessages?: string | null;
  status?: ScanStatus | null;
  extractedResults?: string | null;
  missingFieldsCount?: number | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateInvoiceScanTaskMutation = {
  __typename: "InvoiceScanTask";
  id: string;
  invoiceID?: string | null;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  folderScanTaskID?: string | null;
  folderScanTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdByID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  worker?: {
    __typename: "Worker";
    id: string;
    name: string;
    status: WorkerStatus;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateInvoiceScanTaskMutation = {
  __typename: "InvoiceScanTask";
  id: string;
  invoiceID?: string | null;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  folderScanTaskID?: string | null;
  folderScanTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdByID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  worker?: {
    __typename: "Worker";
    id: string;
    name: string;
    status: WorkerStatus;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteInvoiceScanTaskMutation = {
  __typename: "InvoiceScanTask";
  id: string;
  invoiceID?: string | null;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  folderScanTaskID?: string | null;
  folderScanTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdByID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  worker?: {
    __typename: "Worker";
    id: string;
    name: string;
    status: WorkerStatus;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateCodebookMutation = {
  __typename: "Codebook";
  id: string;
  companyName: string;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code: string;
  vatNumber?: string | null;
  clientID: string;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCodebookMutation = {
  __typename: "Codebook";
  id: string;
  companyName: string;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code: string;
  vatNumber?: string | null;
  clientID: string;
  createdAt: string;
  updatedAt: string;
};

export type DeleteCodebookMutation = {
  __typename: "Codebook";
  id: string;
  companyName: string;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code: string;
  vatNumber?: string | null;
  clientID: string;
  createdAt: string;
  updatedAt: string;
};

export type CreateTemplateMutation = {
  __typename: "Template";
  id: string;
  name: string;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template: string;
  productsEnabled?: TF | null;
  clientIDProductsEnabledPK?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateTemplateMutation = {
  __typename: "Template";
  id: string;
  name: string;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template: string;
  productsEnabled?: TF | null;
  clientIDProductsEnabledPK?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteTemplateMutation = {
  __typename: "Template";
  id: string;
  name: string;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template: string;
  productsEnabled?: TF | null;
  clientIDProductsEnabledPK?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateSystemConfigurationMutation = {
  __typename: "SystemConfiguration";
  id: string;
  value: string;
  type: string;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSystemConfigurationMutation = {
  __typename: "SystemConfiguration";
  id: string;
  value: string;
  type: string;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteSystemConfigurationMutation = {
  __typename: "SystemConfiguration";
  id: string;
  value: string;
  type: string;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateWorkerMutation = {
  __typename: "Worker";
  id: string;
  name: string;
  status: WorkerStatus;
  createdAt: string;
  updatedAt: string;
};

export type UpdateWorkerMutation = {
  __typename: "Worker";
  id: string;
  name: string;
  status: WorkerStatus;
  createdAt: string;
  updatedAt: string;
};

export type DeleteWorkerMutation = {
  __typename: "Worker";
  id: string;
  name: string;
  status: WorkerStatus;
  createdAt: string;
  updatedAt: string;
};

export type UpdateMapperConfigurationMutation = {
  __typename: "MapperConfiguration";
  id: string;
  clientID?: string | null;
  type: MapConfigurationType;
  configuration: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type DeleteMapperConfigurationMutation = {
  __typename: "MapperConfiguration";
  id: string;
  clientID?: string | null;
  type: MapConfigurationType;
  configuration: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type CreateFiaReportJobMutation = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<{
    __typename: "SelectedColumn";
    fieldType: FiaReportFieldType;
    index?: number | null;
    columnName?: string | null;
  } | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  exportedFileUrl?: string | null;
  missingKeys?: {
    __typename: "MissingKeys";
    keys?: string | null;
    dismissed?: number | null;
  } | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateFiaReportJobMutation = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<{
    __typename: "SelectedColumn";
    fieldType: FiaReportFieldType;
    index?: number | null;
    columnName?: string | null;
  } | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  exportedFileUrl?: string | null;
  missingKeys?: {
    __typename: "MissingKeys";
    keys?: string | null;
    dismissed?: number | null;
  } | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteFiaReportJobMutation = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<{
    __typename: "SelectedColumn";
    fieldType: FiaReportFieldType;
    index?: number | null;
    columnName?: string | null;
  } | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  exportedFileUrl?: string | null;
  missingKeys?: {
    __typename: "MissingKeys";
    keys?: string | null;
    dismissed?: number | null;
  } | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

export type SearchAllQuery = {
  __typename: "SearchAllOutput";
  folders?: Array<{
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  invoices?: Array<{
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null> | null;
  nextToken?: string | null;
};

export type ExportFolderInvoicesQuery = {
  __typename: "ModelExportFolderInvoicesOutput";
  output?: {
    __typename: "ModelExportFolderInvoicesDataOutput";
    fileName?: string | null;
    mimeType?: string | null;
    fileContent?: string | null;
  } | null;
};

export type GetStatisticsQuery = {
  __typename: "ModelGetStatisticsOutput";
  scans?: string | null;
  clients?: string | null;
};

export type ExportFolderFromNanoQuery = {
  __typename: "ExportFolderFromNanoOutput";
  csvFileUrl?: string | null;
  xlsxFileUrl?: string | null;
};

export type GetUserQuery = {
  __typename: "User";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  status?: ClientStatus | null;
  type: UserType;
  createdAt: string;
  updatedAt: string;
};

export type ListUsersQuery = {
  __typename: "ModelUserConnection";
  items: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetUserByUsernameQuery = {
  __typename: "ModelUserConnection";
  items: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetUserByEmailQuery = {
  __typename: "ModelUserConnection";
  items: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetUserByPhoneQuery = {
  __typename: "ModelUserConnection";
  items: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetClientQuery = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  logoUrl?: string | null;
  folders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: {
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type ListClientsQuery = {
  __typename: "ModelClientConnection";
  items: Array<{
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  }>;
  nextToken?: string | null;
  scannedCount?: string | null;
};

export type GetClientByUsernameQuery = {
  __typename: "ModelClientConnection";
  items: Array<{
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  }>;
  nextToken?: string | null;
  scannedCount?: string | null;
};

export type GetClientByEmailQuery = {
  __typename: "ModelClientConnection";
  items: Array<{
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  }>;
  nextToken?: string | null;
  scannedCount?: string | null;
};

export type GetClientByPhoneQuery = {
  __typename: "ModelClientConnection";
  items: Array<{
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  }>;
  nextToken?: string | null;
  scannedCount?: string | null;
};

export type GetClientsByViberIDQuery = {
  __typename: "ModelClientConnection";
  items: Array<{
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  }>;
  nextToken?: string | null;
  scannedCount?: string | null;
};

export type GetFolderQuery = {
  __typename: "Folder";
  id: string;
  name: string;
  searchKeyword?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  invoices?: {
    __typename: "ModelInvoiceConnection";
    nextToken?: string | null;
  } | null;
  latestFolderInvoiceTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  exportStatus?: FolderExportStatus | null;
  latestCompletedAt?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  parentFolderID?: string | null;
  parentFolder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  childFolders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  clientIDParentFolderIDPK?: string | null;
  isDeleted?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type ListFoldersQuery = {
  __typename: "ModelFolderConnection";
  items: Array<{
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListFoldersByClientIDQuery = {
  __typename: "ModelFolderConnection";
  items: Array<{
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListFoldersByParentFolderIDQuery = {
  __typename: "ModelFolderConnection";
  items: Array<{
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListFoldersByClientIDParentFolderIDPKQuery = {
  __typename: "ModelFolderConnection";
  items: Array<{
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type SearchFoldersQuery = {
  __typename: "SearchableFolderConnection";
  items: Array<{
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
  total?: number | null;
  aggregateItems: Array<{
    __typename: "SearchableAggregateResult";
    name: string;
    result:
    | (
      | {
        __typename: "SearchableAggregateScalarResult";
        value: number;
      }
      | {
        __typename: "SearchableAggregateBucketResult";
        buckets?: Array<{
          __typename: string;
          key: string;
          doc_count: number;
        } | null> | null;
      }
    )
    | null;
  } | null>;
};

export type GetInvoiceQuery = {
  __typename: "Invoice";
  id: string;
  name: string;
  folderID: string;
  folderIDIsDeletedPK?: string | null;
  clientID: string;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  index: number;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  rotateAngle: number;
  invoiceUserAssignments?: {
    __typename: "ModelInvoiceUserAssignmentConnection";
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
  nanonets?: {
    __typename: "NanonetsInfo";
    previewUrl?: string | null;
    fileID?: string | null;
    modelID?: string | null;
    expiresAt?: number | null;
    redirectUrl?: string | null;
  } | null;
  nanonetsID?: string | null;
  title?: string | null;
  searchToken?: string | null;
  isDeleted?: boolean | null;
};

export type ListInvoicesQuery = {
  __typename: "ModelInvoiceConnection";
  items: Array<{
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null>;
  nextToken?: string | null;
};

export type ListInvoicesByFolderIDQuery = {
  __typename: "ModelInvoiceConnection";
  items: Array<{
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null>;
  nextToken?: string | null;
};

export type ListInvoicesByFolderIDIsDeletedPKQuery = {
  __typename: "ModelInvoiceConnection";
  items: Array<{
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null>;
  nextToken?: string | null;
};

export type ListInvoicesByNanonetsIDQuery = {
  __typename: "ModelInvoiceConnection";
  items: Array<{
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null>;
  nextToken?: string | null;
};

export type SearchInvoicesQuery = {
  __typename: "SearchableInvoiceConnection";
  items: Array<{
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null>;
  nextToken?: string | null;
  total?: number | null;
  aggregateItems: Array<{
    __typename: "SearchableAggregateResult";
    name: string;
    result:
    | (
      | {
        __typename: "SearchableAggregateScalarResult";
        value: number;
      }
      | {
        __typename: "SearchableAggregateBucketResult";
        buckets?: Array<{
          __typename: string;
          key: string;
          doc_count: number;
        } | null> | null;
      }
    )
    | null;
  } | null>;
};

export type GetInvoiceUserAssignmentQuery = {
  __typename: "InvoiceUserAssignment";
  id: string;
  invoiceID: string;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  clientID: string;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  email: string;
  role?: string | null;
  notified: TF;
  createdAt: string;
  updatedAt: string;
};

export type ListInvoiceUserAssignmentsQuery = {
  __typename: "ModelInvoiceUserAssignmentConnection";
  items: Array<{
    __typename: "InvoiceUserAssignment";
    id: string;
    invoiceID: string;
    clientID: string;
    email: string;
    role?: string | null;
    notified: TF;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListInvoiceUserAssignmentsByInvoiceIDQuery = {
  __typename: "ModelInvoiceUserAssignmentConnection";
  items: Array<{
    __typename: "InvoiceUserAssignment";
    id: string;
    invoiceID: string;
    clientID: string;
    email: string;
    role?: string | null;
    notified: TF;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListInvoiceUserAssignmentsByClientIDQuery = {
  __typename: "ModelInvoiceUserAssignmentConnection";
  items: Array<{
    __typename: "InvoiceUserAssignment";
    id: string;
    invoiceID: string;
    clientID: string;
    email: string;
    role?: string | null;
    notified: TF;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListInvoiceUserAssignmentsByEmailQuery = {
  __typename: "ModelInvoiceUserAssignmentConnection";
  items: Array<{
    __typename: "InvoiceUserAssignment";
    id: string;
    invoiceID: string;
    clientID: string;
    email: string;
    role?: string | null;
    notified: TF;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetFolderScanTaskQuery = {
  __typename: "FolderScanTask";
  id: string;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  clientID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  taskCount?: number | null;
  processedTaskCount?: number | null;
  failedTaskCount?: number | null;
  executionTime?: number | null;
  logMessages?: string | null;
  status?: ScanStatus | null;
  extractedResults?: string | null;
  missingFieldsCount?: number | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type ListFolderScanTasksQuery = {
  __typename: "ModelFolderScanTaskConnection";
  items: Array<{
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListFolderScanTasksByFolderIDQuery = {
  __typename: "ModelFolderScanTaskConnection";
  items: Array<{
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetInvoiceScanTaskQuery = {
  __typename: "InvoiceScanTask";
  id: string;
  invoiceID?: string | null;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  folderScanTaskID?: string | null;
  folderScanTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdByID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  worker?: {
    __typename: "Worker";
    id: string;
    name: string;
    status: WorkerStatus;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type ListInvoiceScanTasksQuery = {
  __typename: "ModelInvoiceScanTaskConnection";
  items: Array<{
    __typename: "InvoiceScanTask";
    id: string;
    invoiceID?: string | null;
    folderScanTaskID?: string | null;
    folderID?: string | null;
    createdByID?: string | null;
    logMessages?: string | null;
    queueID?: string | null;
    workerID?: string | null;
    extractedResults?: string | null;
    missingFields?: string | null;
    executionTime?: number | null;
    status?: ScanStatus | null;
    originalScanResults?: string | null;
    extractedProductsResults?: string | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetInvoiceScanTaskByFolderScanTaskIDQuery = {
  __typename: "ModelInvoiceScanTaskConnection";
  items: Array<{
    __typename: "InvoiceScanTask";
    id: string;
    invoiceID?: string | null;
    folderScanTaskID?: string | null;
    folderID?: string | null;
    createdByID?: string | null;
    logMessages?: string | null;
    queueID?: string | null;
    workerID?: string | null;
    extractedResults?: string | null;
    missingFields?: string | null;
    executionTime?: number | null;
    status?: ScanStatus | null;
    originalScanResults?: string | null;
    extractedProductsResults?: string | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetCodebookQuery = {
  __typename: "Codebook";
  id: string;
  companyName: string;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code: string;
  vatNumber?: string | null;
  clientID: string;
  createdAt: string;
  updatedAt: string;
};

export type ListCodebooksQuery = {
  __typename: "ModelCodebookConnection";
  items: Array<{
    __typename: "Codebook";
    id: string;
    companyName: string;
    searchKeyword?: string | null;
    idNumber?: string | null;
    code: string;
    vatNumber?: string | null;
    clientID: string;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetCodebookByClientIDQuery = {
  __typename: "ModelCodebookConnection";
  items: Array<{
    __typename: "Codebook";
    id: string;
    companyName: string;
    searchKeyword?: string | null;
    idNumber?: string | null;
    code: string;
    vatNumber?: string | null;
    clientID: string;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetTemplateQuery = {
  __typename: "Template";
  id: string;
  name: string;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template: string;
  productsEnabled?: TF | null;
  isFixedValueEnabled: String | null;
  fixedValues: String | null;
  clientIDProductsEnabledPK?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListTemplatesQuery = {
  __typename: "ModelTemplateConnection";
  items: Array<{
    __typename: "Template";
    id: string;
    name: string;
    searchKeyword?: string | null;
    description?: string | null;
    clientID?: string | null;
    template: string;
    productsEnabled?: TF | null;
    clientIDProductsEnabledPK?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListTemplatesByClientIDQuery = {
  __typename: "ModelTemplateConnection";
  items: Array<{
    __typename: "Template";
    id: string;
    name: string;
    searchKeyword?: string | null;
    description?: string | null;
    clientID?: string | null;
    template: string;
    productsEnabled?: TF | null;
    clientIDProductsEnabledPK?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListTemplatesByProductsEnabledQuery = {
  __typename: "ModelTemplateConnection";
  items: Array<{
    __typename: "Template";
    id: string;
    name: string;
    searchKeyword?: string | null;
    description?: string | null;
    clientID?: string | null;
    template: string;
    productsEnabled?: TF | null;
    clientIDProductsEnabledPK?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListTemplatesByClientIDProductsEnabledPKQuery = {
  __typename: "ModelTemplateConnection";
  items: Array<{
    __typename: "Template";
    id: string;
    name: string;
    searchKeyword?: string | null;
    description?: string | null;
    clientID?: string | null;
    template: string;
    productsEnabled?: TF | null;
    clientIDProductsEnabledPK?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetSystemConfigurationQuery = {
  __typename: "SystemConfiguration";
  id: string;
  value: string;
  type: string;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListSystemConfigurationsQuery = {
  __typename: "ModelSystemConfigurationConnection";
  items: Array<{
    __typename: "SystemConfiguration";
    id: string;
    value: string;
    type: string;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListSystemConfigurationsByTypeQuery = {
  __typename: "ModelSystemConfigurationConnection";
  items: Array<{
    __typename: "SystemConfiguration";
    id: string;
    value: string;
    type: string;
    note?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetWorkerQuery = {
  __typename: "Worker";
  id: string;
  name: string;
  status: WorkerStatus;
  createdAt: string;
  updatedAt: string;
};

export type ListWorkersQuery = {
  __typename: "ModelWorkerConnection";
  items: Array<{
    __typename: "Worker";
    id: string;
    name: string;
    status: WorkerStatus;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetMapperConfigurationQuery = {
  __typename: "MapperConfiguration";
  id: string;
  clientID?: string | null;
  type: MapConfigurationType;
  configuration: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ListMapperConfigurationsQuery = {
  __typename: "ModelMapperConfigurationConnection";
  items: Array<{
    __typename: "MapperConfiguration";
    id: string;
    clientID?: string | null;
    type: MapConfigurationType;
    configuration: string;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null>;
  nextToken?: string | null;
};

export type GetMapperConfigurationByClientIDQuery = {
  __typename: "ModelMapperConfigurationConnection";
  items: Array<{
    __typename: "MapperConfiguration";
    id: string;
    clientID?: string | null;
    type: MapConfigurationType;
    configuration: string;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null>;
  nextToken?: string | null;
};

export type GetMapperConfigurationByTypeQuery = {
  __typename: "ModelMapperConfigurationConnection";
  items: Array<{
    __typename: "MapperConfiguration";
    id: string;
    clientID?: string | null;
    type: MapConfigurationType;
    configuration: string;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null>;
  nextToken?: string | null;
};

export type GetFiaReportJobQuery = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<{
    __typename: "SelectedColumn";
    fieldType: FiaReportFieldType;
    index?: number | null;
    columnName?: string | null;
  } | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  exportedFileUrl?: string | null;
  missingKeys?: {
    __typename: "MissingKeys";
    keys?: string | null;
    dismissed?: number | null;
  } | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

export type ListFiaReportJobsQuery = {
  __typename: "ModelFiaReportJobConnection";
  items: Array<{
    __typename: "FiaReportJob";
    id: string;
    token?: string | null;
    userID?: string | null;
    status: FiaReportJobStatus;
    userIDStatusPK?: string | null;
    spreadSheetUrl?: string | null;
    proxySheetUrl?: string | null;
    sourceType?: FiaReportSourceType | null;
    source?: string | null;
    sourcePdf?: string | null;
    sourceDisplay?: string | null;
    errorMessage?: string | null;
    tableColumns?: Array<string | null> | null;
    skipColumnSelection?: boolean | null;
    tablesJsonUrl?: string | null;
    previousSpreadsheetUrl?: string | null;
    permissionToEmail?: string | null;
    exportedFileUrl?: string | null;
    companyName?: string | null;
    thumbnailUrls?: Array<string | null> | null;
    downloaded?: TF | null;
    downloadedUserIDPK?: string | null;
    companyType?: CompanyType | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListFiaReportJobsByUserQuery = {
  __typename: "ModelFiaReportJobConnection";
  items: Array<{
    __typename: "FiaReportJob";
    id: string;
    token?: string | null;
    userID?: string | null;
    status: FiaReportJobStatus;
    userIDStatusPK?: string | null;
    spreadSheetUrl?: string | null;
    proxySheetUrl?: string | null;
    sourceType?: FiaReportSourceType | null;
    source?: string | null;
    sourcePdf?: string | null;
    sourceDisplay?: string | null;
    errorMessage?: string | null;
    tableColumns?: Array<string | null> | null;
    skipColumnSelection?: boolean | null;
    tablesJsonUrl?: string | null;
    previousSpreadsheetUrl?: string | null;
    permissionToEmail?: string | null;
    exportedFileUrl?: string | null;
    companyName?: string | null;
    thumbnailUrls?: Array<string | null> | null;
    downloaded?: TF | null;
    downloadedUserIDPK?: string | null;
    companyType?: CompanyType | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListFiaReportJobsByStatusQuery = {
  __typename: "ModelFiaReportJobConnection";
  items: Array<{
    __typename: "FiaReportJob";
    id: string;
    token?: string | null;
    userID?: string | null;
    status: FiaReportJobStatus;
    userIDStatusPK?: string | null;
    spreadSheetUrl?: string | null;
    proxySheetUrl?: string | null;
    sourceType?: FiaReportSourceType | null;
    source?: string | null;
    sourcePdf?: string | null;
    sourceDisplay?: string | null;
    errorMessage?: string | null;
    tableColumns?: Array<string | null> | null;
    skipColumnSelection?: boolean | null;
    tablesJsonUrl?: string | null;
    previousSpreadsheetUrl?: string | null;
    permissionToEmail?: string | null;
    exportedFileUrl?: string | null;
    companyName?: string | null;
    thumbnailUrls?: Array<string | null> | null;
    downloaded?: TF | null;
    downloadedUserIDPK?: string | null;
    companyType?: CompanyType | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ListFiaReportJobsByUserIDStatusPKQuery = {
  __typename: "ModelFiaReportJobConnection";
  items: Array<{
    __typename: "FiaReportJob";
    id: string;
    token?: string | null;
    userID?: string | null;
    status: FiaReportJobStatus;
    userIDStatusPK?: string | null;
    spreadSheetUrl?: string | null;
    proxySheetUrl?: string | null;
    sourceType?: FiaReportSourceType | null;
    source?: string | null;
    sourcePdf?: string | null;
    sourceDisplay?: string | null;
    errorMessage?: string | null;
    tableColumns?: Array<string | null> | null;
    skipColumnSelection?: boolean | null;
    tablesJsonUrl?: string | null;
    previousSpreadsheetUrl?: string | null;
    permissionToEmail?: string | null;
    exportedFileUrl?: string | null;
    companyName?: string | null;
    thumbnailUrls?: Array<string | null> | null;
    downloaded?: TF | null;
    downloadedUserIDPK?: string | null;
    companyType?: CompanyType | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type OnCreateInvoiceSubscription = {
  __typename: "Invoice";
  id: string;
  name: string;
  folderID: string;
  folderIDIsDeletedPK?: string | null;
  clientID: string;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  index: number;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  rotateAngle: number;
  invoiceUserAssignments?: {
    __typename: "ModelInvoiceUserAssignmentConnection";
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
  nanonets?: {
    __typename: "NanonetsInfo";
    previewUrl?: string | null;
    fileID?: string | null;
    modelID?: string | null;
    expiresAt?: number | null;
    redirectUrl?: string | null;
  } | null;
  nanonetsID?: string | null;
  title?: string | null;
  searchToken?: string | null;
  isDeleted?: boolean | null;
};

export type OnUpdateInvoiceSubscription = {
  __typename: "Invoice";
  id: string;
  name: string;
  folderID: string;
  folderIDIsDeletedPK?: string | null;
  clientID: string;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  index: number;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  rotateAngle: number;
  invoiceUserAssignments?: {
    __typename: "ModelInvoiceUserAssignmentConnection";
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
  nanonets?: {
    __typename: "NanonetsInfo";
    previewUrl?: string | null;
    fileID?: string | null;
    modelID?: string | null;
    expiresAt?: number | null;
    redirectUrl?: string | null;
  } | null;
  nanonetsID?: string | null;
  title?: string | null;
  searchToken?: string | null;
  isDeleted?: boolean | null;
};

export type OnUpdateUserSubscription = {
  __typename: "User";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  status?: ClientStatus | null;
  type: UserType;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteUserSubscription = {
  __typename: "User";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  status?: ClientStatus | null;
  type: UserType;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateClientSubscription = {
  __typename: "Client";
  id: string;
  username: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  company: string;
  phone: string;
  address?: string | null;
  city?: string | null;
  folders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  totalScanCount?: number | null;
  expirationDate?: string | null;
  isVatIncluded?: TF | null;
  status?: ClientStatus | null;
  userID?: string | null;
  user?: {
    __typename: "User";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    status?: ClientStatus | null;
    type: UserType;
    createdAt: string;
    updatedAt: string;
  } | null;
  viberID?: string | null;
  totalFiaReportProcessCount?: number | null;
  fiaAccessStatus?: ClientFiaAccessStatus | null;
  createdAt: string;
  updatedAt: string;
  downloadQuota?: number | null;
  reportQuota?: number | null;
  downloadedCount?: number | null;
};

export type OnCreateFolderSubscription = {
  __typename: "Folder";
  id: string;
  name: string;
  searchKeyword?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  invoices?: {
    __typename: "ModelInvoiceConnection";
    nextToken?: string | null;
  } | null;
  latestFolderInvoiceTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  exportStatus?: FolderExportStatus | null;
  latestCompletedAt?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  parentFolderID?: string | null;
  parentFolder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  childFolders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  clientIDParentFolderIDPK?: string | null;
  isDeleted?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateFolderSubscription = {
  __typename: "Folder";
  id: string;
  name: string;
  searchKeyword?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  invoices?: {
    __typename: "ModelInvoiceConnection";
    nextToken?: string | null;
  } | null;
  latestFolderInvoiceTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderScanTasks?: {
    __typename: "ModelFolderScanTaskConnection";
    nextToken?: string | null;
  } | null;
  exportStatus?: FolderExportStatus | null;
  latestCompletedAt?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  parentFolderID?: string | null;
  parentFolder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  childFolders?: {
    __typename: "ModelFolderConnection";
    nextToken?: string | null;
  } | null;
  clientIDParentFolderIDPK?: string | null;
  isDeleted?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateInvoiceUserAssignmentSubscription = {
  __typename: "InvoiceUserAssignment";
  id: string;
  invoiceID: string;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  clientID: string;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  email: string;
  role?: string | null;
  notified: TF;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateFolderScanTaskSubscription = {
  __typename: "FolderScanTask";
  id: string;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  clientID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  taskCount?: number | null;
  processedTaskCount?: number | null;
  failedTaskCount?: number | null;
  executionTime?: number | null;
  logMessages?: string | null;
  status?: ScanStatus | null;
  extractedResults?: string | null;
  missingFieldsCount?: number | null;
  invoiceScanTasks?: {
    __typename: "ModelInvoiceScanTaskConnection";
    nextToken?: string | null;
  } | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateInvoiceScanTaskSubscription = {
  __typename: "InvoiceScanTask";
  id: string;
  invoiceID?: string | null;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  folderScanTaskID?: string | null;
  folderScanTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdByID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  worker?: {
    __typename: "Worker";
    id: string;
    name: string;
    status: WorkerStatus;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateInvoiceScanTaskSubscription = {
  __typename: "InvoiceScanTask";
  id: string;
  invoiceID?: string | null;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  folderScanTaskID?: string | null;
  folderScanTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdByID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  worker?: {
    __typename: "Worker";
    id: string;
    name: string;
    status: WorkerStatus;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteInvoiceScanTaskSubscription = {
  __typename: "InvoiceScanTask";
  id: string;
  invoiceID?: string | null;
  invoice?: {
    __typename: "Invoice";
    id: string;
    name: string;
    folderID: string;
    folderIDIsDeletedPK?: string | null;
    clientID: string;
    extractedResults?: string | null;
    missingFields?: string | null;
    thumbnailPath?: string | null;
    index: number;
    extractedProductsResults?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    rotateAngle: number;
    createdAt: string;
    updatedAt: string;
    nanonetsID?: string | null;
    title?: string | null;
    searchToken?: string | null;
    isDeleted?: boolean | null;
  } | null;
  folderScanTaskID?: string | null;
  folderScanTask?: {
    __typename: "FolderScanTask";
    id: string;
    folderID?: string | null;
    clientID?: string | null;
    taskCount?: number | null;
    processedTaskCount?: number | null;
    failedTaskCount?: number | null;
    executionTime?: number | null;
    logMessages?: string | null;
    status?: ScanStatus | null;
    extractedResults?: string | null;
    missingFieldsCount?: number | null;
    isScanIncludedProducts?: TF | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  folderID?: string | null;
  folder?: {
    __typename: "Folder";
    id: string;
    name: string;
    searchKeyword?: string | null;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    exportStatus?: FolderExportStatus | null;
    latestCompletedAt?: string | null;
    isLatestScanIncludedProducts?: TF | null;
    parentFolderID?: string | null;
    clientIDParentFolderIDPK?: string | null;
    isDeleted?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdByID?: string | null;
  client?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  logMessages?: string | null;
  queueID?: string | null;
  workerID?: string | null;
  worker?: {
    __typename: "Worker";
    id: string;
    name: string;
    status: WorkerStatus;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  missingFields?: string | null;
  executionTime?: number | null;
  status?: ScanStatus | null;
  originalScanResults?: string | null;
  extractedProductsResults?: string | null;
  isScanIncludedProducts?: TF | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateCodebookSubscription = {
  __typename: "Codebook";
  id: string;
  companyName: string;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code: string;
  vatNumber?: string | null;
  clientID: string;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateCodebookSubscription = {
  __typename: "Codebook";
  id: string;
  companyName: string;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code: string;
  vatNumber?: string | null;
  clientID: string;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteCodebookSubscription = {
  __typename: "Codebook";
  id: string;
  companyName: string;
  searchKeyword?: string | null;
  idNumber?: string | null;
  code: string;
  vatNumber?: string | null;
  clientID: string;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateTemplateSubscription = {
  __typename: "Template";
  id: string;
  name: string;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template: string;
  productsEnabled?: TF | null;
  clientIDProductsEnabledPK?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateTemplateSubscription = {
  __typename: "Template";
  id: string;
  name: string;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template: string;
  productsEnabled?: TF | null;
  clientIDProductsEnabledPK?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteTemplateSubscription = {
  __typename: "Template";
  id: string;
  name: string;
  searchKeyword?: string | null;
  description?: string | null;
  clientID?: string | null;
  template: string;
  productsEnabled?: TF | null;
  clientIDProductsEnabledPK?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateSystemConfigurationSubscription = {
  __typename: "SystemConfiguration";
  id: string;
  value: string;
  type: string;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateSystemConfigurationSubscription = {
  __typename: "SystemConfiguration";
  id: string;
  value: string;
  type: string;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteSystemConfigurationSubscription = {
  __typename: "SystemConfiguration";
  id: string;
  value: string;
  type: string;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateWorkerSubscription = {
  __typename: "Worker";
  id: string;
  name: string;
  status: WorkerStatus;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateWorkerSubscription = {
  __typename: "Worker";
  id: string;
  name: string;
  status: WorkerStatus;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteWorkerSubscription = {
  __typename: "Worker";
  id: string;
  name: string;
  status: WorkerStatus;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateMapperConfigurationSubscription = {
  __typename: "MapperConfiguration";
  id: string;
  clientID?: string | null;
  type: MapConfigurationType;
  configuration: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type OnDeleteMapperConfigurationSubscription = {
  __typename: "MapperConfiguration";
  id: string;
  clientID?: string | null;
  type: MapConfigurationType;
  configuration: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type OnCreateFiaReportJobSubscription = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<{
    __typename: "SelectedColumn";
    fieldType: FiaReportFieldType;
    index?: number | null;
    columnName?: string | null;
  } | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  exportedFileUrl?: string | null;
  missingKeys?: {
    __typename: "MissingKeys";
    keys?: string | null;
    dismissed?: number | null;
  } | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateFiaReportJobSubscription = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<{
    __typename: "SelectedColumn";
    fieldType: FiaReportFieldType;
    index?: number | null;
    columnName?: string | null;
  } | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  exportedFileUrl?: string | null;
  missingKeys?: {
    __typename: "MissingKeys";
    keys?: string | null;
    dismissed?: number | null;
  } | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteFiaReportJobSubscription = {
  __typename: "FiaReportJob";
  id: string;
  token?: string | null;
  userID?: string | null;
  status: FiaReportJobStatus;
  userIDStatusPK?: string | null;
  spreadSheetUrl?: string | null;
  proxySheetUrl?: string | null;
  sourceType?: FiaReportSourceType | null;
  source?: string | null;
  sourcePdf?: string | null;
  sourceDisplay?: string | null;
  errorMessage?: string | null;
  tableColumns?: Array<string | null> | null;
  selectedColumns?: Array<{
    __typename: "SelectedColumn";
    fieldType: FiaReportFieldType;
    index?: number | null;
    columnName?: string | null;
  } | null> | null;
  skipColumnSelection?: boolean | null;
  tablesJsonUrl?: string | null;
  previousSpreadsheetUrl?: string | null;
  permissionToEmail?: string | null;
  user?: {
    __typename: "Client";
    id: string;
    username: string;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    company: string;
    phone: string;
    address?: string | null;
    city?: string | null;
    totalScanCount?: number | null;
    expirationDate?: string | null;
    isVatIncluded?: TF | null;
    status?: ClientStatus | null;
    userID?: string | null;
    viberID?: string | null;
    totalFiaReportProcessCount?: number | null;
    fiaAccessStatus?: ClientFiaAccessStatus | null;
    createdAt: string;
    updatedAt: string;
    downloadQuota?: number | null;
    reportQuota?: number | null;
    downloadedCount?: number | null;
  } | null;
  exportedFileUrl?: string | null;
  missingKeys?: {
    __typename: "MissingKeys";
    keys?: string | null;
    dismissed?: number | null;
  } | null;
  companyName?: string | null;
  thumbnailUrls?: Array<string | null> | null;
  downloaded?: TF | null;
  downloadedUserIDPK?: string | null;
  companyType?: CompanyType | null;
  createdAt: string;
  updatedAt: string;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async DownloadFiaReport(
    input: DownloadFiaReportInput
  ): Promise<DownloadFiaReportMutation> {
    const statement = `mutation DownloadFiaReport($input: DownloadFiaReportInput!) {
        downloadFiaReport(input: $input) {
          __typename
          id
          token
          userID
          status
          userIDStatusPK
          spreadSheetUrl
          proxySheetUrl
          sourceType
          source
          sourcePdf
          sourceDisplay
          errorMessage
          tableColumns
          selectedColumns {
            __typename
            fieldType
            index
            columnName
          }
          skipColumnSelection
          tablesJsonUrl
          previousSpreadsheetUrl
          permissionToEmail
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          exportedFileUrl
          missingKeys {
            __typename
            keys
            dismissed
          }
          companyName
          thumbnailUrls
          downloaded
          downloadedUserIDPK
          companyType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DownloadFiaReportMutation>response.data.downloadFiaReport;
  }
  async UpdateClientStatus(
    input: UpdateClientStatusInput
  ): Promise<UpdateClientStatusMutation> {
    const statement = `mutation UpdateClientStatus($input: UpdateClientStatusInput!) {
        updateClientStatus(input: $input) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          city
          folders {
            __typename
            nextToken
          }
          folderScanTasks {
            __typename
            nextToken
          }
          totalScanCount
          expirationDate
          isVatIncluded
          status
          userID
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          viberID
          totalFiaReportProcessCount
          fiaAccessStatus
          createdAt
          updatedAt
          downloadQuota
          reportQuota
          downloadedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateClientStatusMutation>response.data.updateClientStatus;
  }
  async GenerateFiaReport(
    input: GenerateFiaReportInput
  ): Promise<GenerateFiaReportMutation> {
    const statement = `mutation GenerateFiaReport($input: GenerateFiaReportInput!) {
        generateFiaReport(input: $input) {
          __typename
          id
          token
          userID
          status
          userIDStatusPK
          spreadSheetUrl
          proxySheetUrl
          sourceType
          source
          sourcePdf
          sourceDisplay
          errorMessage
          tableColumns
          selectedColumns {
            __typename
            fieldType
            index
            columnName
          }
          skipColumnSelection
          tablesJsonUrl
          previousSpreadsheetUrl
          permissionToEmail
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          exportedFileUrl
          missingKeys {
            __typename
            keys
            dismissed
          }
          companyName
          thumbnailUrls
          downloaded
          downloadedUserIDPK
          companyType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GenerateFiaReportMutation>response.data.generateFiaReport;
  }
  async CompleteFiaReport(
    input: CompleteFiaReportInput
  ): Promise<CompleteFiaReportMutation> {
    const statement = `mutation CompleteFiaReport($input: CompleteFiaReportInput!) {
        completeFiaReport(input: $input) {
          __typename
          statusCode
          body
          headers
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CompleteFiaReportMutation>response.data.completeFiaReport;
  }
  async ExportFiaReport(
    input: ExportFiaReportInput
  ): Promise<ExportFiaReportMutation> {
    const statement = `mutation ExportFiaReport($input: ExportFiaReportInput!) {
        exportFiaReport(input: $input) {
          __typename
          statusCode
          body
          headers
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ExportFiaReportMutation>response.data.exportFiaReport;
  }
  async ProcessCICReport(
    input: ProcessCICReportInput
  ): Promise<ProcessCICReportMutation> {
    const statement = `mutation ProcessCICReport($input: ProcessCICReportInput!) {
        processCICReport(input: $input) {
          __typename
          statusCode
          body
          headers
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ProcessCICReportMutation>response.data.processCICReport;
  }
  async GeneratePreviewUrl(
    input: GeneratePreviewUrlInput
  ): Promise<GeneratePreviewUrlMutation> {
    const statement = `mutation GeneratePreviewUrl($input: GeneratePreviewUrlInput!) {
        generatePreviewUrl(input: $input) {
          __typename
          id
          name
          folderID
          folderIDIsDeletedPK
          clientID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          thumbnailPath
          invoiceScanTasks {
            __typename
            nextToken
          }
          index
          extractedProductsResults
          isLatestScanIncludedProducts
          rotateAngle
          invoiceUserAssignments {
            __typename
            nextToken
          }
          createdAt
          updatedAt
          nanonets {
            __typename
            previewUrl
            fileID
            modelID
            expiresAt
            redirectUrl
          }
          nanonetsID
          title
          searchToken
          isDeleted
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GeneratePreviewUrlMutation>response.data.generatePreviewUrl;
  }
  async PredictFolder(
    input: PredictFolderInput
  ): Promise<PredictFolderMutation> {
    const statement = `mutation PredictFolder($input: PredictFolderInput!) {
        predictFolder(input: $input) {
          __typename
          invoices {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PredictFolderMutation>response.data.predictFolder;
  }
  async PredictFolderAsync(
    input: PredictFolderInput
  ): Promise<PredictFolderAsyncMutation> {
    const statement = `mutation PredictFolderAsync($input: PredictFolderInput!) {
        predictFolderAsync(input: $input) {
          __typename
          statusCode
          body
          headers
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PredictFolderAsyncMutation>response.data.predictFolderAsync;
  }
  async TestExceptionIdentity(
    input?: TestExceptionIdentityInput
  ): Promise<TestExceptionIdentityMutation> {
    const statement = `mutation TestExceptionIdentity($input: TestExceptionIdentityInput) {
        testExceptionIdentity(input: $input) {
          __typename
          matchedIdentities {
            __typename
            key
            value
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <TestExceptionIdentityMutation>response.data.testExceptionIdentity;
  }
  async IncrementClientCounters(
    input?: IncrementClientCountersInput
  ): Promise<IncrementClientCountersMutation> {
    const statement = `mutation IncrementClientCounters($input: IncrementClientCountersInput) {
        incrementClientCounters(input: $input) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          city
          folders {
            __typename
            nextToken
          }
          folderScanTasks {
            __typename
            nextToken
          }
          totalScanCount
          expirationDate
          isVatIncluded
          status
          userID
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          viberID
          totalFiaReportProcessCount
          fiaAccessStatus
          createdAt
          updatedAt
          downloadQuota
          reportQuota
          downloadedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <IncrementClientCountersMutation>(
      response.data.incrementClientCounters
    );
  }
  async CreateClient(
    client: CreateClientInput,
    condition?: ModelClientConditionInput
  ): Promise<CreateClientMutation> {
    const statement = `mutation CreateClient($client: CreateClientInput!, $condition: ModelClientConditionInput) {
        createClient(client: $client, condition: $condition) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          city
          logoUrl
          folders {
            __typename
            nextToken
          }
          folderScanTasks {
            __typename
            nextToken
          }
          totalScanCount
          expirationDate
          isVatIncluded
          status
          userID
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          viberID
          totalFiaReportProcessCount
          fiaAccessStatus
          createdAt
          updatedAt
          downloadQuota
          reportQuota
          downloadedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {
      client
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateClientMutation>response.data.createClient;
  }
  async CreateFolderScanTask(
    input: ModelCreateFolderScanTaskInput
  ): Promise<CreateFolderScanTaskMutation> {
    const statement = `mutation CreateFolderScanTask($input: ModelCreateFolderScanTaskInput!) {
        createFolderScanTask(input: $input) {
          __typename
          id
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          taskCount
          processedTaskCount
          failedTaskCount
          executionTime
          logMessages
          status
          extractedResults
          missingFieldsCount
          invoiceScanTasks {
            __typename
            nextToken
          }
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateFolderScanTaskMutation>response.data.createFolderScanTask;
  }
  async IncreaseProcessedTaskCountInFolderScanTask(
    folderScanTaskID: string
  ): Promise<IncreaseProcessedTaskCountInFolderScanTaskMutation> {
    const statement = `mutation IncreaseProcessedTaskCountInFolderScanTask($folderScanTaskID: ID!) {
        increaseProcessedTaskCountInFolderScanTask(folderScanTaskID: $folderScanTaskID) {
          __typename
          id
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          taskCount
          processedTaskCount
          failedTaskCount
          executionTime
          logMessages
          status
          extractedResults
          missingFieldsCount
          invoiceScanTasks {
            __typename
            nextToken
          }
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      folderScanTaskID
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <IncreaseProcessedTaskCountInFolderScanTaskMutation>(
      response.data.increaseProcessedTaskCountInFolderScanTask
    );
  }
  async IncreaseFailedTaskCountInFolderScanTask(
    folderScanTaskID: string
  ): Promise<IncreaseFailedTaskCountInFolderScanTaskMutation> {
    const statement = `mutation IncreaseFailedTaskCountInFolderScanTask($folderScanTaskID: ID!) {
        increaseFailedTaskCountInFolderScanTask(folderScanTaskID: $folderScanTaskID) {
          __typename
          id
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          taskCount
          processedTaskCount
          failedTaskCount
          executionTime
          logMessages
          status
          extractedResults
          missingFieldsCount
          invoiceScanTasks {
            __typename
            nextToken
          }
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      folderScanTaskID
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <IncreaseFailedTaskCountInFolderScanTaskMutation>(
      response.data.increaseFailedTaskCountInFolderScanTask
    );
  }
  async AppendFolderScanTaskLogMessage(
    input: ModelAppendFolderScanTaskLogMessageInput
  ): Promise<AppendFolderScanTaskLogMessageMutation> {
    const statement = `mutation AppendFolderScanTaskLogMessage($input: ModelAppendFolderScanTaskLogMessageInput!) {
        appendFolderScanTaskLogMessage(input: $input) {
          __typename
          id
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          taskCount
          processedTaskCount
          failedTaskCount
          executionTime
          logMessages
          status
          extractedResults
          missingFieldsCount
          invoiceScanTasks {
            __typename
            nextToken
          }
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <AppendFolderScanTaskLogMessageMutation>(
      response.data.appendFolderScanTaskLogMessage
    );
  }
  async CreatePresignedURL(
    input?: ModelCreatePresignedURLInput
  ): Promise<CreatePresignedURLMutation> {
    const statement = `mutation CreatePresignedURL($input: ModelCreatePresignedURLInput) {
        createPresignedURL(input: $input) {
          __typename
          url
          filePath
          mimeType
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePresignedURLMutation>response.data.createPresignedURL;
  }
  async CancelFolderScanTask(
    input?: ModelCancelFolderScanTaskInput
  ): Promise<CancelFolderScanTaskMutation> {
    const statement = `mutation CancelFolderScanTask($input: ModelCancelFolderScanTaskInput) {
        cancelFolderScanTask(input: $input) {
          __typename
          result
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CancelFolderScanTaskMutation>response.data.cancelFolderScanTask;
  }
  async BulkCodebookImport(
    input?: ModelBulkCodebookImportInput
  ): Promise<BulkCodebookImportMutation> {
    const statement = `mutation BulkCodebookImport($input: ModelBulkCodebookImportInput) {
        bulkCodebookImport(input: $input) {
          __typename
          result
          message
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <BulkCodebookImportMutation>response.data.bulkCodebookImport;
  }
  async BulkInvoiceDelete(
    input?: ModelBulkInvoiceDeleteInput
  ): Promise<BulkInvoiceDeleteMutation> {
    const statement = `mutation BulkInvoiceDelete($input: ModelBulkInvoiceDeleteInput) {
        bulkInvoiceDelete(input: $input) {
          __typename
          result
          message
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <BulkInvoiceDeleteMutation>response.data.bulkInvoiceDelete;
  }
  async SendEmail(input?: ModelSendEmailInput): Promise<SendEmailMutation> {
    const statement = `mutation SendEmail($input: ModelSendEmailInput) {
        sendEmail(input: $input) {
          __typename
          result
          message
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SendEmailMutation>response.data.sendEmail;
  }
  async ContactForm(
    input?: ModelContactFormInput
  ): Promise<ContactFormMutation> {
    const statement = `mutation ContactForm($input: ModelContactFormInput) {
        contactForm(input: $input) {
          __typename
          result
          message
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ContactFormMutation>response.data.contactForm;
  }
  async CreateTrialUser(
    input?: ModelCreateTrialUserInput
  ): Promise<CreateTrialUserMutation> {
    const statement = `mutation CreateTrialUser($input: ModelCreateTrialUserInput) {
        createTrialUser(input: $input) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          city
          logoUrl
          folders {
            __typename
            nextToken
          }
          folderScanTasks {
            __typename
            nextToken
          }
          totalScanCount
          expirationDate
          isVatIncluded
          status
          userID
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          viberID
          totalFiaReportProcessCount
          fiaAccessStatus
          createdAt
          updatedAt
          downloadQuota
          reportQuota
          downloadedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateTrialUserMutation>response.data.createTrialUser;
  }
  async CreateMapperConfiguration(
    input: CreateMapperConfigurationInput
  ): Promise<CreateMapperConfigurationMutation> {
    const statement = `mutation CreateMapperConfiguration($input: CreateMapperConfigurationInput!) {
        createMapperConfiguration(input: $input) {
          __typename
          id
          clientID
          type
          configuration
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateMapperConfigurationMutation>(
      response.data.createMapperConfiguration
    );
  }
  async ResolveKeys(input?: HandleKeysInput): Promise<ResolveKeysMutation> {
    const statement = `mutation ResolveKeys($input: HandleKeysInput) {
        resolveKeys(input: $input) {
          __typename
          success
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ResolveKeysMutation>response.data.resolveKeys;
  }
  async CreateInvoice(
    input: CreateInvoiceInput,
    condition?: ModelInvoiceConditionInput
  ): Promise<CreateInvoiceMutation> {
    const statement = `mutation CreateInvoice($input: CreateInvoiceInput!, $condition: ModelInvoiceConditionInput) {
        createInvoice(input: $input, condition: $condition) {
          __typename
          id
          name
          folderID
          folderIDIsDeletedPK
          clientID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          thumbnailPath
          invoiceScanTasks {
            __typename
            nextToken
          }
          index
          extractedProductsResults
          isLatestScanIncludedProducts
          rotateAngle
          invoiceUserAssignments {
            __typename
            nextToken
          }
          createdAt
          updatedAt
          nanonets {
            __typename
            previewUrl
            fileID
            modelID
            expiresAt
            redirectUrl
          }
          nanonetsID
          title
          searchToken
          isDeleted
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateInvoiceMutation>response.data.createInvoice;
  }
  async UpdateInvoice(
    input: UpdateInvoiceInput,
    condition?: ModelInvoiceConditionInput
  ): Promise<UpdateInvoiceMutation> {
    const statement = `mutation UpdateInvoice($input: UpdateInvoiceInput!, $condition: ModelInvoiceConditionInput) {
        updateInvoice(input: $input, condition: $condition) {
          __typename
          id
          name
          folderID
          folderIDIsDeletedPK
          clientID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          thumbnailPath
          invoiceScanTasks {
            __typename
            nextToken
          }
          index
          extractedProductsResults
          isLatestScanIncludedProducts
          rotateAngle
          invoiceUserAssignments {
            __typename
            nextToken
          }
          createdAt
          updatedAt
          nanonets {
            __typename
            previewUrl
            fileID
            modelID
            expiresAt
            redirectUrl
          }
          nanonetsID
          title
          searchToken
          isDeleted
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateInvoiceMutation>response.data.updateInvoice;
  }
  async DeleteFolder(
    input: DeleteFolderInput,
    condition?: ModelFolderConditionInput
  ): Promise<DeleteFolderMutation> {
    const statement = `mutation DeleteFolder($input: DeleteFolderInput!, $condition: ModelFolderConditionInput) {
        deleteFolder(input: $input, condition: $condition) {
          __typename
          id
          name
          searchKeyword
          clientID
          downloadLink
          status
          latestFolderInvoiceTaskID
          areThereMissingFields
          invoicesCount
          invoices {
            __typename
            nextToken
          }
          latestFolderInvoiceTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderScanTasks {
            __typename
            nextToken
          }
          exportStatus
          latestCompletedAt
          isLatestScanIncludedProducts
          parentFolderID
          parentFolder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          childFolders {
            __typename
            nextToken
          }
          clientIDParentFolderIDPK
          isDeleted
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteFolderMutation>response.data.deleteFolder;
  }
  async DeleteClient(
    input: DeleteClientInput,
    condition?: ModelClientConditionInput
  ): Promise<DeleteClientMutation> {
    const statement = `mutation DeleteClient($input: DeleteClientInput!, $condition: ModelClientConditionInput) {
        deleteClient(input: $input, condition: $condition) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          city
          folders {
            __typename
            nextToken
          }
          folderScanTasks {
            __typename
            nextToken
          }
          totalScanCount
          expirationDate
          isVatIncluded
          status
          userID
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          viberID
          totalFiaReportProcessCount
          fiaAccessStatus
          createdAt
          updatedAt
          downloadQuota
          reportQuota
          downloadedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteClientMutation>response.data.deleteClient;
  }
  async DeleteInvoice(
    input: DeleteInvoiceInput,
    condition?: ModelInvoiceConditionInput
  ): Promise<DeleteInvoiceMutation> {
    const statement = `mutation DeleteInvoice($input: DeleteInvoiceInput!, $condition: ModelInvoiceConditionInput) {
        deleteInvoice(input: $input, condition: $condition) {
          __typename
          id
          name
          folderID
          folderIDIsDeletedPK
          clientID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          thumbnailPath
          invoiceScanTasks {
            __typename
            nextToken
          }
          index
          extractedProductsResults
          isLatestScanIncludedProducts
          rotateAngle
          invoiceUserAssignments {
            __typename
            nextToken
          }
          createdAt
          updatedAt
          nanonets {
            __typename
            previewUrl
            fileID
            modelID
            expiresAt
            redirectUrl
          }
          nanonetsID
          title
          searchToken
          isDeleted
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteInvoiceMutation>response.data.deleteInvoice;
  }
  async BulkDeleteService(
    input?: BulkDeleteServiceInput
  ): Promise<BulkDeleteServiceMutation> {
    const statement = `mutation BulkDeleteService($input: BulkDeleteServiceInput) {
        bulkDeleteService(input: $input) {
          __typename
          success
          message
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <BulkDeleteServiceMutation>response.data.bulkDeleteService;
  }
  async CreateUser(input: CreateUserInput): Promise<CreateUserMutation> {
    const statement = `mutation CreateUser($input: CreateUserInput!) {
        createUser(input: $input) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          status
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateUserMutation>response.data.createUser;
  }
  async AuthenticateViberID(
    token?: string
  ): Promise<AuthenticateViberIDMutation> {
    const statement = `mutation AuthenticateViberID($token: String) {
        authenticateViberID(token: $token) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          city
          folders {
            __typename
            nextToken
          }
          folderScanTasks {
            __typename
            nextToken
          }
          totalScanCount
          expirationDate
          isVatIncluded
          status
          userID
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          viberID
          totalFiaReportProcessCount
          fiaAccessStatus
          createdAt
          updatedAt
          downloadQuota
          reportQuota
          downloadedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (token) {
      gqlAPIServiceArguments.token = token;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <AuthenticateViberIDMutation>response.data.authenticateViberID;
  }
  async UpdateInvoiceOrder(
    input?: UpdateInvoicePositionInput
  ): Promise<UpdateInvoiceOrderMutation> {
    const statement = `mutation UpdateInvoiceOrder($input: UpdateInvoicePositionInput) {
        updateInvoiceOrder(input: $input) {
          __typename
          success
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateInvoiceOrderMutation>response.data.updateInvoiceOrder;
  }
  async CreateInvoiceUserAssignment(
    input: Array<CreateInvoiceUserAssignmentInput>
  ): Promise<Array<CreateInvoiceUserAssignmentMutation>> {
    const statement = `mutation CreateInvoiceUserAssignment($input: [CreateInvoiceUserAssignmentInput!]!) {
        createInvoiceUserAssignment(input: $input) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          email
          role
          notified
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <Array<CreateInvoiceUserAssignmentMutation>>(
      response.data.createInvoiceUserAssignment
    );
  }
  async DeleteInvoiceUserAssignment(
    input: Array<string>
  ): Promise<Array<DeleteInvoiceUserAssignmentMutation>> {
    const statement = `mutation DeleteInvoiceUserAssignment($input: [ID!]!) {
        deleteInvoiceUserAssignment(input: $input) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          email
          role
          notified
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <Array<DeleteInvoiceUserAssignmentMutation>>(
      response.data.deleteInvoiceUserAssignment
    );
  }
  async UpdateUser(
    input: UpdateUserInput,
    condition?: ModelUserConditionInput
  ): Promise<UpdateUserMutation> {
    const statement = `mutation UpdateUser($input: UpdateUserInput!, $condition: ModelUserConditionInput) {
        updateUser(input: $input, condition: $condition) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          status
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateUserMutation>response.data.updateUser;
  }
  async DeleteUser(
    input: DeleteUserInput,
    condition?: ModelUserConditionInput
  ): Promise<DeleteUserMutation> {
    const statement = `mutation DeleteUser($input: DeleteUserInput!, $condition: ModelUserConditionInput) {
        deleteUser(input: $input, condition: $condition) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          status
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteUserMutation>response.data.deleteUser;
  }
  async UpdateClient(
    input: UpdateClientInput,
    condition?: ModelClientConditionInput
  ): Promise<UpdateClientMutation> {
    const statement = `mutation UpdateClient($input: UpdateClientInput!, $condition: ModelClientConditionInput) {
        updateClient(input: $input, condition: $condition) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          city
          folders {
            __typename
            nextToken
          }
          folderScanTasks {
            __typename
            nextToken
          }
          totalScanCount
          expirationDate
          isVatIncluded
          status
          userID
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          viberID
          totalFiaReportProcessCount
          fiaAccessStatus
          createdAt
          updatedAt
          downloadQuota
          reportQuota
          downloadedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateClientMutation>response.data.updateClient;
  }
  async CreateFolder(
    input: CreateFolderInput,
    condition?: ModelFolderConditionInput
  ): Promise<CreateFolderMutation> {
    const statement = `mutation CreateFolder($input: CreateFolderInput!, $condition: ModelFolderConditionInput) {
        createFolder(input: $input, condition: $condition) {
          __typename
          id
          name
          searchKeyword
          clientID
          downloadLink
          status
          latestFolderInvoiceTaskID
          areThereMissingFields
          invoicesCount
          invoices {
            __typename
            nextToken
          }
          latestFolderInvoiceTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderScanTasks {
            __typename
            nextToken
          }
          exportStatus
          latestCompletedAt
          isLatestScanIncludedProducts
          parentFolderID
          parentFolder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          childFolders {
            __typename
            nextToken
          }
          clientIDParentFolderIDPK
          isDeleted
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateFolderMutation>response.data.createFolder;
  }
  async UpdateFolder(
    input: UpdateFolderInput,
    condition?: ModelFolderConditionInput
  ): Promise<UpdateFolderMutation> {
    const statement = `mutation UpdateFolder($input: UpdateFolderInput!, $condition: ModelFolderConditionInput) {
        updateFolder(input: $input, condition: $condition) {
          __typename
          id
          name
          searchKeyword
          clientID
          downloadLink
          status
          latestFolderInvoiceTaskID
          areThereMissingFields
          invoicesCount
          invoices {
            __typename
            nextToken
          }
          latestFolderInvoiceTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderScanTasks {
            __typename
            nextToken
          }
          exportStatus
          latestCompletedAt
          isLatestScanIncludedProducts
          parentFolderID
          parentFolder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          childFolders {
            __typename
            nextToken
          }
          clientIDParentFolderIDPK
          isDeleted
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateFolderMutation>response.data.updateFolder;
  }
  async UpdateInvoiceUserAssignment(
    input: UpdateInvoiceUserAssignmentInput,
    condition?: ModelInvoiceUserAssignmentConditionInput
  ): Promise<UpdateInvoiceUserAssignmentMutation> {
    const statement = `mutation UpdateInvoiceUserAssignment($input: UpdateInvoiceUserAssignmentInput!, $condition: ModelInvoiceUserAssignmentConditionInput) {
        updateInvoiceUserAssignment(input: $input, condition: $condition) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          email
          role
          notified
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateInvoiceUserAssignmentMutation>(
      response.data.updateInvoiceUserAssignment
    );
  }
  async UpdateFolderScanTask(
    input: UpdateFolderScanTaskInput,
    condition?: ModelFolderScanTaskConditionInput
  ): Promise<UpdateFolderScanTaskMutation> {
    const statement = `mutation UpdateFolderScanTask($input: UpdateFolderScanTaskInput!, $condition: ModelFolderScanTaskConditionInput) {
        updateFolderScanTask(input: $input, condition: $condition) {
          __typename
          id
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          taskCount
          processedTaskCount
          failedTaskCount
          executionTime
          logMessages
          status
          extractedResults
          missingFieldsCount
          invoiceScanTasks {
            __typename
            nextToken
          }
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateFolderScanTaskMutation>response.data.updateFolderScanTask;
  }
  async CreateInvoiceScanTask(
    input: CreateInvoiceScanTaskInput,
    condition?: ModelInvoiceScanTaskConditionInput
  ): Promise<CreateInvoiceScanTaskMutation> {
    const statement = `mutation CreateInvoiceScanTask($input: CreateInvoiceScanTaskInput!, $condition: ModelInvoiceScanTaskConditionInput) {
        createInvoiceScanTask(input: $input, condition: $condition) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          folderScanTaskID
          folderScanTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          createdByID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          logMessages
          queueID
          workerID
          worker {
            __typename
            id
            name
            status
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          executionTime
          status
          originalScanResults
          extractedProductsResults
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateInvoiceScanTaskMutation>response.data.createInvoiceScanTask;
  }
  async UpdateInvoiceScanTask(
    input: UpdateInvoiceScanTaskInput,
    condition?: ModelInvoiceScanTaskConditionInput
  ): Promise<UpdateInvoiceScanTaskMutation> {
    const statement = `mutation UpdateInvoiceScanTask($input: UpdateInvoiceScanTaskInput!, $condition: ModelInvoiceScanTaskConditionInput) {
        updateInvoiceScanTask(input: $input, condition: $condition) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          folderScanTaskID
          folderScanTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          createdByID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          logMessages
          queueID
          workerID
          worker {
            __typename
            id
            name
            status
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          executionTime
          status
          originalScanResults
          extractedProductsResults
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateInvoiceScanTaskMutation>response.data.updateInvoiceScanTask;
  }
  async DeleteInvoiceScanTask(
    input: DeleteInvoiceScanTaskInput,
    condition?: ModelInvoiceScanTaskConditionInput
  ): Promise<DeleteInvoiceScanTaskMutation> {
    const statement = `mutation DeleteInvoiceScanTask($input: DeleteInvoiceScanTaskInput!, $condition: ModelInvoiceScanTaskConditionInput) {
        deleteInvoiceScanTask(input: $input, condition: $condition) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          folderScanTaskID
          folderScanTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          createdByID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          logMessages
          queueID
          workerID
          worker {
            __typename
            id
            name
            status
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          executionTime
          status
          originalScanResults
          extractedProductsResults
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteInvoiceScanTaskMutation>response.data.deleteInvoiceScanTask;
  }
  async CreateCodebook(
    input: CreateCodebookInput,
    condition?: ModelCodebookConditionInput
  ): Promise<CreateCodebookMutation> {
    const statement = `mutation CreateCodebook($input: CreateCodebookInput!, $condition: ModelCodebookConditionInput) {
        createCodebook(input: $input, condition: $condition) {
          __typename
          id
          companyName
          searchKeyword
          idNumber
          code
          vatNumber
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateCodebookMutation>response.data.createCodebook;
  }
  async UpdateCodebook(
    input: UpdateCodebookInput,
    condition?: ModelCodebookConditionInput
  ): Promise<UpdateCodebookMutation> {
    const statement = `mutation UpdateCodebook($input: UpdateCodebookInput!, $condition: ModelCodebookConditionInput) {
        updateCodebook(input: $input, condition: $condition) {
          __typename
          id
          companyName
          searchKeyword
          idNumber
          code
          vatNumber
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateCodebookMutation>response.data.updateCodebook;
  }
  async DeleteCodebook(
    input: DeleteCodebookInput,
    condition?: ModelCodebookConditionInput
  ): Promise<DeleteCodebookMutation> {
    const statement = `mutation DeleteCodebook($input: DeleteCodebookInput!, $condition: ModelCodebookConditionInput) {
        deleteCodebook(input: $input, condition: $condition) {
          __typename
          id
          companyName
          searchKeyword
          idNumber
          code
          vatNumber
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCodebookMutation>response.data.deleteCodebook;
  }
  async CreateTemplate(
    input: CreateTemplateInput,
    condition?: ModelTemplateConditionInput
  ): Promise<CreateTemplateMutation> {
    const statement = `mutation CreateTemplate($input: CreateTemplateInput!, $condition: ModelTemplateConditionInput) {
        createTemplate(input: $input, condition: $condition) {
          __typename
          id
          name
          searchKeyword
          description
          clientID
          template
          productsEnabled
          clientIDProductsEnabledPK
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateTemplateMutation>response.data.createTemplate;
  }
  async UpdateTemplate(
    input: UpdateTemplateInput,
    condition?: ModelTemplateConditionInput
  ): Promise<UpdateTemplateMutation> {
    const statement = `mutation UpdateTemplate($input: UpdateTemplateInput!, $condition: ModelTemplateConditionInput) {
        updateTemplate(input: $input, condition: $condition) {
          __typename
          id
          name
          searchKeyword
          description
          clientID
          template
          productsEnabled
          clientIDProductsEnabledPK
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateTemplateMutation>response.data.updateTemplate;
  }
  async DeleteTemplate(
    input: DeleteTemplateInput,
    condition?: ModelTemplateConditionInput
  ): Promise<DeleteTemplateMutation> {
    const statement = `mutation DeleteTemplate($input: DeleteTemplateInput!, $condition: ModelTemplateConditionInput) {
        deleteTemplate(input: $input, condition: $condition) {
          __typename
          id
          name
          searchKeyword
          description
          clientID
          template
          productsEnabled
          clientIDProductsEnabledPK
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteTemplateMutation>response.data.deleteTemplate;
  }
  async CreateSystemConfiguration(
    input: CreateSystemConfigurationInput,
    condition?: ModelSystemConfigurationConditionInput
  ): Promise<CreateSystemConfigurationMutation> {
    const statement = `mutation CreateSystemConfiguration($input: CreateSystemConfigurationInput!, $condition: ModelSystemConfigurationConditionInput) {
        createSystemConfiguration(input: $input, condition: $condition) {
          __typename
          id
          value
          type
          note
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateSystemConfigurationMutation>(
      response.data.createSystemConfiguration
    );
  }
  async UpdateSystemConfiguration(
    input: UpdateSystemConfigurationInput,
    condition?: ModelSystemConfigurationConditionInput
  ): Promise<UpdateSystemConfigurationMutation> {
    const statement = `mutation UpdateSystemConfiguration($input: UpdateSystemConfigurationInput!, $condition: ModelSystemConfigurationConditionInput) {
        updateSystemConfiguration(input: $input, condition: $condition) {
          __typename
          id
          value
          type
          note
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateSystemConfigurationMutation>(
      response.data.updateSystemConfiguration
    );
  }
  async DeleteSystemConfiguration(
    input: DeleteSystemConfigurationInput,
    condition?: ModelSystemConfigurationConditionInput
  ): Promise<DeleteSystemConfigurationMutation> {
    const statement = `mutation DeleteSystemConfiguration($input: DeleteSystemConfigurationInput!, $condition: ModelSystemConfigurationConditionInput) {
        deleteSystemConfiguration(input: $input, condition: $condition) {
          __typename
          id
          value
          type
          note
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteSystemConfigurationMutation>(
      response.data.deleteSystemConfiguration
    );
  }
  async CreateWorker(
    input: CreateWorkerInput,
    condition?: ModelWorkerConditionInput
  ): Promise<CreateWorkerMutation> {
    const statement = `mutation CreateWorker($input: CreateWorkerInput!, $condition: ModelWorkerConditionInput) {
        createWorker(input: $input, condition: $condition) {
          __typename
          id
          name
          status
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateWorkerMutation>response.data.createWorker;
  }
  async UpdateWorker(
    input: UpdateWorkerInput,
    condition?: ModelWorkerConditionInput
  ): Promise<UpdateWorkerMutation> {
    const statement = `mutation UpdateWorker($input: UpdateWorkerInput!, $condition: ModelWorkerConditionInput) {
        updateWorker(input: $input, condition: $condition) {
          __typename
          id
          name
          status
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateWorkerMutation>response.data.updateWorker;
  }
  async DeleteWorker(
    input: DeleteWorkerInput,
    condition?: ModelWorkerConditionInput
  ): Promise<DeleteWorkerMutation> {
    const statement = `mutation DeleteWorker($input: DeleteWorkerInput!, $condition: ModelWorkerConditionInput) {
        deleteWorker(input: $input, condition: $condition) {
          __typename
          id
          name
          status
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteWorkerMutation>response.data.deleteWorker;
  }
  async UpdateMapperConfiguration(
    input: UpdateMapperConfigurationInput,
    condition?: ModelMapperConfigurationConditionInput
  ): Promise<UpdateMapperConfigurationMutation> {
    const statement = `mutation UpdateMapperConfiguration($input: UpdateMapperConfigurationInput!, $condition: ModelMapperConfigurationConditionInput) {
        updateMapperConfiguration(input: $input, condition: $condition) {
          __typename
          id
          clientID
          type
          configuration
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateMapperConfigurationMutation>(
      response.data.updateMapperConfiguration
    );
  }
  async DeleteMapperConfiguration(
    input: DeleteMapperConfigurationInput,
    condition?: ModelMapperConfigurationConditionInput
  ): Promise<DeleteMapperConfigurationMutation> {
    const statement = `mutation DeleteMapperConfiguration($input: DeleteMapperConfigurationInput!, $condition: ModelMapperConfigurationConditionInput) {
        deleteMapperConfiguration(input: $input, condition: $condition) {
          __typename
          id
          clientID
          type
          configuration
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteMapperConfigurationMutation>(
      response.data.deleteMapperConfiguration
    );
  }
  async CreateFiaReportJob(
    input: CreateFiaReportJobInput,
    condition?: ModelFiaReportJobConditionInput
  ): Promise<CreateFiaReportJobMutation> {
    const statement = `mutation CreateFiaReportJob($input: CreateFiaReportJobInput!, $condition: ModelFiaReportJobConditionInput) {
        createFiaReportJob(input: $input, condition: $condition) {
          __typename
          id
          token
          userID
          status
          userIDStatusPK
          spreadSheetUrl
          proxySheetUrl
          sourceType
          source
          sourcePdf
          sourceDisplay
          errorMessage
          tableColumns
          selectedColumns {
            __typename
            fieldType
            index
            columnName
          }
          skipColumnSelection
          tablesJsonUrl
          previousSpreadsheetUrl
          permissionToEmail
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          exportedFileUrl
          missingKeys {
            __typename
            keys
            dismissed
          }
          companyName
          thumbnailUrls
          downloaded
          downloadedUserIDPK
          companyType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateFiaReportJobMutation>response.data.createFiaReportJob;
  }
  async UpdateFiaReportJob(
    input: UpdateFiaReportJobInput,
    condition?: ModelFiaReportJobConditionInput
  ): Promise<UpdateFiaReportJobMutation> {
    const statement = `mutation UpdateFiaReportJob($input: UpdateFiaReportJobInput!, $condition: ModelFiaReportJobConditionInput) {
        updateFiaReportJob(input: $input, condition: $condition) {
          __typename
          id
          token
          userID
          status
          userIDStatusPK
          spreadSheetUrl
          proxySheetUrl
          sourceType
          source
          sourcePdf
          sourceDisplay
          errorMessage
          tableColumns
          selectedColumns {
            __typename
            fieldType
            index
            columnName
          }
          skipColumnSelection
          tablesJsonUrl
          previousSpreadsheetUrl
          permissionToEmail
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          exportedFileUrl
          missingKeys {
            __typename
            keys
            dismissed
          }
          companyName
          thumbnailUrls
          downloaded
          downloadedUserIDPK
          companyType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateFiaReportJobMutation>response.data.updateFiaReportJob;
  }
  async DeleteFiaReportJob(
    input: DeleteFiaReportJobInput,
    condition?: ModelFiaReportJobConditionInput
  ): Promise<DeleteFiaReportJobMutation> {
    const statement = `mutation DeleteFiaReportJob($input: DeleteFiaReportJobInput!, $condition: ModelFiaReportJobConditionInput) {
        deleteFiaReportJob(input: $input, condition: $condition) {
          __typename
          id
          token
          userID
          status
          userIDStatusPK
          spreadSheetUrl
          proxySheetUrl
          sourceType
          source
          sourcePdf
          sourceDisplay
          errorMessage
          tableColumns
          selectedColumns {
            __typename
            fieldType
            index
            columnName
          }
          skipColumnSelection
          tablesJsonUrl
          previousSpreadsheetUrl
          permissionToEmail
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          exportedFileUrl
          missingKeys {
            __typename
            keys
            dismissed
          }
          companyName
          thumbnailUrls
          downloaded
          downloadedUserIDPK
          companyType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteFiaReportJobMutation>response.data.deleteFiaReportJob;
  }
  async SearchAll(
    keyword: string,
    limit?: number,
    nextToken?: string,
    sort?: Array<SearchableAllSortInput | null>
  ): Promise<SearchAllQuery> {
    const statement = `query SearchAll($keyword: String!, $limit: Int, $nextToken: String, $sort: [SearchableAllSortInput]) {
        searchAll(keyword: $keyword, limit: $limit, nextToken: $nextToken, sort: $sort) {
          __typename
          folders {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          invoices {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      keyword
    };
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (sort) {
      gqlAPIServiceArguments.sort = sort;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SearchAllQuery>response.data.searchAll;
  }
  async ExportFolderInvoices(
    input?: ModelExportFolderInvoicesInput
  ): Promise<ExportFolderInvoicesQuery> {
    const statement = `query ExportFolderInvoices($input: ModelExportFolderInvoicesInput) {
        exportFolderInvoices(input: $input) {
          __typename
          output {
            __typename
            fileName
            mimeType
            fileContent
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ExportFolderInvoicesQuery>response.data.exportFolderInvoices;
  }
  async GetStatistics(timestamp?: string): Promise<GetStatisticsQuery> {
    const statement = `query GetStatistics($timestamp: String) {
        getStatistics(timestamp: $timestamp) {
          __typename
          scans
          clients
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (timestamp) {
      gqlAPIServiceArguments.timestamp = timestamp;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetStatisticsQuery>response.data.getStatistics;
  }
  async ExportFolderFromNano(
    input: ExportFolderFromNanoInput
  ): Promise<ExportFolderFromNanoQuery> {
    const statement = `query ExportFolderFromNano($input: ExportFolderFromNanoInput!) {
        exportFolderFromNano(input: $input) {
          __typename
          csvFileUrl
          xlsxFileUrl
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ExportFolderFromNanoQuery>response.data.exportFolderFromNano;
  }
  async GetUser(id: string): Promise<GetUserQuery> {
    const statement = `query GetUser($id: ID!) {
        getUser(id: $id) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          status
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetUserQuery>response.data.getUser;
  }
  async ListUsers(
    filter?: ModelUserFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListUsersQuery> {
    const statement = `query ListUsers($filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
        listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListUsersQuery>response.data.listUsers;
  }
  async GetUserByUsername(
    username: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelUserFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetUserByUsernameQuery> {
    const statement = `query GetUserByUsername($username: String!, $sortDirection: ModelSortDirection, $filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
        getUserByUsername(
          username: $username
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      username
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetUserByUsernameQuery>response.data.getUserByUsername;
  }
  async GetUserByEmail(
    email: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelUserFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetUserByEmailQuery> {
    const statement = `query GetUserByEmail($email: String!, $sortDirection: ModelSortDirection, $filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
        getUserByEmail(
          email: $email
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      email
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetUserByEmailQuery>response.data.getUserByEmail;
  }
  async GetUserByPhone(
    phone: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelUserFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetUserByPhoneQuery> {
    const statement = `query GetUserByPhone($phone: String!, $sortDirection: ModelSortDirection, $filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
        getUserByPhone(
          phone: $phone
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      phone
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetUserByPhoneQuery>response.data.getUserByPhone;
  }
  async GetClient(id: string): Promise<GetClientQuery> {
    const statement = `query GetClient($id: ID!) {
        getClient(id: $id) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          city
          logoUrl
          folders {
            __typename
            nextToken
          }
          folderScanTasks {
            __typename
            nextToken
          }
          totalScanCount
          expirationDate
          isVatIncluded
          status
          userID
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          viberID
          totalFiaReportProcessCount
          fiaAccessStatus
          createdAt
          updatedAt
          downloadQuota
          reportQuota
          downloadedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetClientQuery>response.data.getClient;
  }
  async ListClients(
    filter?: ModelClientFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListClientsQuery> {
    const statement = `query ListClients($filter: ModelClientFilterInput, $limit: Int, $nextToken: String) {
        listClients(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          nextToken
          scannedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListClientsQuery>response.data.listClients;
  }
  async GetClientByUsername(
    username: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelClientFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetClientByUsernameQuery> {
    const statement = `query GetClientByUsername($username: String!, $sortDirection: ModelSortDirection, $filter: ModelClientFilterInput, $limit: Int, $nextToken: String) {
        getClientByUsername(
          username: $username
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          nextToken
          scannedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {
      username
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetClientByUsernameQuery>response.data.getClientByUsername;
  }
  async GetClientByEmail(
    email: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelClientFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetClientByEmailQuery> {
    const statement = `query GetClientByEmail($email: String!, $sortDirection: ModelSortDirection, $filter: ModelClientFilterInput, $limit: Int, $nextToken: String) {
        getClientByEmail(
          email: $email
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          nextToken
          scannedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {
      email
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetClientByEmailQuery>response.data.getClientByEmail;
  }
  async GetClientByPhone(
    phone: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelClientFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetClientByPhoneQuery> {
    const statement = `query GetClientByPhone($phone: String!, $sortDirection: ModelSortDirection, $filter: ModelClientFilterInput, $limit: Int, $nextToken: String) {
        getClientByPhone(
          phone: $phone
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          nextToken
          scannedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {
      phone
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetClientByPhoneQuery>response.data.getClientByPhone;
  }
  async GetClientsByViberID(
    viberID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelClientFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetClientsByViberIDQuery> {
    const statement = `query GetClientsByViberID($viberID: String!, $sortDirection: ModelSortDirection, $filter: ModelClientFilterInput, $limit: Int, $nextToken: String) {
        getClientsByViberID(
          viberID: $viberID
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          nextToken
          scannedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {
      viberID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetClientsByViberIDQuery>response.data.getClientsByViberID;
  }
  async GetFolder(id: string): Promise<GetFolderQuery> {
    const statement = `query GetFolder($id: ID!) {
        getFolder(id: $id) {
          __typename
          id
          name
          searchKeyword
          clientID
          downloadLink
          status
          latestFolderInvoiceTaskID
          areThereMissingFields
          invoicesCount
          invoices {
            __typename
            nextToken
          }
          latestFolderInvoiceTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderScanTasks {
            __typename
            nextToken
          }
          exportStatus
          latestCompletedAt
          isLatestScanIncludedProducts
          parentFolderID
          parentFolder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          childFolders {
            __typename
            nextToken
          }
          clientIDParentFolderIDPK
          isDeleted
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetFolderQuery>response.data.getFolder;
  }
  async ListFolders(
    filter?: ModelFolderFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFoldersQuery> {
    const statement = `query ListFolders($filter: ModelFolderFilterInput, $limit: Int, $nextToken: String) {
        listFolders(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFoldersQuery>response.data.listFolders;
  }
  async ListFoldersByClientID(
    clientID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelFolderFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFoldersByClientIDQuery> {
    const statement = `query ListFoldersByClientID($clientID: ID!, $sortDirection: ModelSortDirection, $filter: ModelFolderFilterInput, $limit: Int, $nextToken: String) {
        listFoldersByClientID(
          clientID: $clientID
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFoldersByClientIDQuery>response.data.listFoldersByClientID;
  }
  async ListFoldersByParentFolderID(
    parentFolderID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelFolderFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFoldersByParentFolderIDQuery> {
    const statement = `query ListFoldersByParentFolderID($parentFolderID: ID!, $sortDirection: ModelSortDirection, $filter: ModelFolderFilterInput, $limit: Int, $nextToken: String) {
        listFoldersByParentFolderID(
          parentFolderID: $parentFolderID
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      parentFolderID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFoldersByParentFolderIDQuery>(
      response.data.listFoldersByParentFolderID
    );
  }
  async ListFoldersByClientIDParentFolderIDPK(
    clientIDParentFolderIDPK: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelFolderFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFoldersByClientIDParentFolderIDPKQuery> {
    const statement = `query ListFoldersByClientIDParentFolderIDPK($clientIDParentFolderIDPK: String!, $sortDirection: ModelSortDirection, $filter: ModelFolderFilterInput, $limit: Int, $nextToken: String) {
        listFoldersByClientIDParentFolderIDPK(
          clientIDParentFolderIDPK: $clientIDParentFolderIDPK
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientIDParentFolderIDPK
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFoldersByClientIDParentFolderIDPKQuery>(
      response.data.listFoldersByClientIDParentFolderIDPK
    );
  }
  async SearchFolders(
    filter?: SearchableFolderFilterInput,
    sort?: Array<SearchableFolderSortInput | null>,
    limit?: number,
    nextToken?: string,
    from?: number,
    aggregates?: Array<SearchableFolderAggregationInput | null>
  ): Promise<SearchFoldersQuery> {
    const statement = `query SearchFolders($filter: SearchableFolderFilterInput, $sort: [SearchableFolderSortInput], $limit: Int, $nextToken: String, $from: Int, $aggregates: [SearchableFolderAggregationInput]) {
        searchFolders(
          filter: $filter
          sort: $sort
          limit: $limit
          nextToken: $nextToken
          from: $from
          aggregates: $aggregates
        ) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
          total
          aggregateItems {
            __typename
            name
            result {
              __typename
              ... on SearchableAggregateScalarResult {
                value
              }
              ... on SearchableAggregateBucketResult {
                buckets {
                  __typename
                  key
                  doc_count
                }
              }
            }
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (sort) {
      gqlAPIServiceArguments.sort = sort;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (from) {
      gqlAPIServiceArguments.from = from;
    }
    if (aggregates) {
      gqlAPIServiceArguments.aggregates = aggregates;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SearchFoldersQuery>response.data.searchFolders;
  }
  async GetInvoice(id: string): Promise<GetInvoiceQuery> {
    const statement = `query GetInvoice($id: ID!) {
        getInvoice(id: $id) {
          __typename
          id
          name
          folderID
          folderIDIsDeletedPK
          clientID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          thumbnailPath
          invoiceScanTasks {
            __typename
            nextToken
          }
          index
          extractedProductsResults
          isLatestScanIncludedProducts
          rotateAngle
          invoiceUserAssignments {
            __typename
            nextToken
          }
          createdAt
          updatedAt
          nanonets {
            __typename
            previewUrl
            fileID
            modelID
            expiresAt
            redirectUrl
          }
          nanonetsID
          title
          searchToken
          isDeleted
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetInvoiceQuery>response.data.getInvoice;
  }
  async ListInvoices(
    filter?: ModelInvoiceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoicesQuery> {
    const statement = `query ListInvoices($filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String) {
        listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoicesQuery>response.data.listInvoices;
  }
  async ListInvoicesByFolderID(
    folderID: string,
    index?: ModelFloatKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelInvoiceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoicesByFolderIDQuery> {
    const statement = `query ListInvoicesByFolderID($folderID: ID!, $index: ModelFloatKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String) {
        listInvoicesByFolderID(
          folderID: $folderID
          index: $index
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      folderID
    };
    if (index) {
      gqlAPIServiceArguments.index = index;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoicesByFolderIDQuery>response.data.listInvoicesByFolderID;
  }
  async ListInvoicesByFolderIDIsDeletedPK(
    folderIDIsDeletedPK: string,
    index?: ModelFloatKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelInvoiceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoicesByFolderIDIsDeletedPKQuery> {
    const statement = `query ListInvoicesByFolderIDIsDeletedPK($folderIDIsDeletedPK: ID!, $index: ModelFloatKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String) {
        listInvoicesByFolderIDIsDeletedPK(
          folderIDIsDeletedPK: $folderIDIsDeletedPK
          index: $index
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      folderIDIsDeletedPK
    };
    if (index) {
      gqlAPIServiceArguments.index = index;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoicesByFolderIDIsDeletedPKQuery>(
      response.data.listInvoicesByFolderIDIsDeletedPK
    );
  }
  async ListInvoicesByNanonetsID(
    nanonetsID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelInvoiceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoicesByNanonetsIDQuery> {
    const statement = `query ListInvoicesByNanonetsID($nanonetsID: String!, $sortDirection: ModelSortDirection, $filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String) {
        listInvoicesByNanonetsID(
          nanonetsID: $nanonetsID
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      nanonetsID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoicesByNanonetsIDQuery>(
      response.data.listInvoicesByNanonetsID
    );
  }
  async SearchInvoices(
    filter?: SearchableInvoiceFilterInput,
    sort?: Array<SearchableInvoiceSortInput | null>,
    limit?: number,
    nextToken?: string,
    from?: number,
    aggregates?: Array<SearchableInvoiceAggregationInput | null>
  ): Promise<SearchInvoicesQuery> {
    const statement = `query SearchInvoices($filter: SearchableInvoiceFilterInput, $sort: [SearchableInvoiceSortInput], $limit: Int, $nextToken: String, $from: Int, $aggregates: [SearchableInvoiceAggregationInput]) {
        searchInvoices(
          filter: $filter
          sort: $sort
          limit: $limit
          nextToken: $nextToken
          from: $from
          aggregates: $aggregates
        ) {
          __typename
          items {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          nextToken
          total
          aggregateItems {
            __typename
            name
            result {
              __typename
              ... on SearchableAggregateScalarResult {
                value
              }
              ... on SearchableAggregateBucketResult {
                buckets {
                  __typename
                  key
                  doc_count
                }
              }
            }
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (sort) {
      gqlAPIServiceArguments.sort = sort;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (from) {
      gqlAPIServiceArguments.from = from;
    }
    if (aggregates) {
      gqlAPIServiceArguments.aggregates = aggregates;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SearchInvoicesQuery>response.data.searchInvoices;
  }
  async GetInvoiceUserAssignment(
    id: string
  ): Promise<GetInvoiceUserAssignmentQuery> {
    const statement = `query GetInvoiceUserAssignment($id: ID!) {
        getInvoiceUserAssignment(id: $id) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          email
          role
          notified
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetInvoiceUserAssignmentQuery>(
      response.data.getInvoiceUserAssignment
    );
  }
  async ListInvoiceUserAssignments(
    filter?: ModelInvoiceUserAssignmentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoiceUserAssignmentsQuery> {
    const statement = `query ListInvoiceUserAssignments($filter: ModelInvoiceUserAssignmentFilterInput, $limit: Int, $nextToken: String) {
        listInvoiceUserAssignments(
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            invoiceID
            clientID
            email
            role
            notified
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoiceUserAssignmentsQuery>(
      response.data.listInvoiceUserAssignments
    );
  }
  async ListInvoiceUserAssignmentsByInvoiceID(
    invoiceID: string,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelInvoiceUserAssignmentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoiceUserAssignmentsByInvoiceIDQuery> {
    const statement = `query ListInvoiceUserAssignmentsByInvoiceID($invoiceID: ID!, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelInvoiceUserAssignmentFilterInput, $limit: Int, $nextToken: String) {
        listInvoiceUserAssignmentsByInvoiceID(
          invoiceID: $invoiceID
          createdAt: $createdAt
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            invoiceID
            clientID
            email
            role
            notified
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      invoiceID
    };
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoiceUserAssignmentsByInvoiceIDQuery>(
      response.data.listInvoiceUserAssignmentsByInvoiceID
    );
  }
  async ListInvoiceUserAssignmentsByClientID(
    clientID: string,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelInvoiceUserAssignmentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoiceUserAssignmentsByClientIDQuery> {
    const statement = `query ListInvoiceUserAssignmentsByClientID($clientID: ID!, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelInvoiceUserAssignmentFilterInput, $limit: Int, $nextToken: String) {
        listInvoiceUserAssignmentsByClientID(
          clientID: $clientID
          createdAt: $createdAt
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            invoiceID
            clientID
            email
            role
            notified
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientID
    };
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoiceUserAssignmentsByClientIDQuery>(
      response.data.listInvoiceUserAssignmentsByClientID
    );
  }
  async ListInvoiceUserAssignmentsByEmail(
    email: string,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelInvoiceUserAssignmentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoiceUserAssignmentsByEmailQuery> {
    const statement = `query ListInvoiceUserAssignmentsByEmail($email: String!, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelInvoiceUserAssignmentFilterInput, $limit: Int, $nextToken: String) {
        listInvoiceUserAssignmentsByEmail(
          email: $email
          createdAt: $createdAt
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            invoiceID
            clientID
            email
            role
            notified
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      email
    };
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoiceUserAssignmentsByEmailQuery>(
      response.data.listInvoiceUserAssignmentsByEmail
    );
  }
  async GetFolderScanTask(id: string): Promise<GetFolderScanTaskQuery> {
    const statement = `query GetFolderScanTask($id: ID!) {
        getFolderScanTask(id: $id) {
          __typename
          id
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          taskCount
          processedTaskCount
          failedTaskCount
          executionTime
          logMessages
          status
          extractedResults
          missingFieldsCount
          invoiceScanTasks {
            __typename
            nextToken
          }
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetFolderScanTaskQuery>response.data.getFolderScanTask;
  }
  async ListFolderScanTasks(
    filter?: ModelFolderScanTaskFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFolderScanTasksQuery> {
    const statement = `query ListFolderScanTasks($filter: ModelFolderScanTaskFilterInput, $limit: Int, $nextToken: String) {
        listFolderScanTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFolderScanTasksQuery>response.data.listFolderScanTasks;
  }
  async ListFolderScanTasksByFolderID(
    folderID: string,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelFolderScanTaskFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFolderScanTasksByFolderIDQuery> {
    const statement = `query ListFolderScanTasksByFolderID($folderID: ID!, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelFolderScanTaskFilterInput, $limit: Int, $nextToken: String) {
        listFolderScanTasksByFolderID(
          folderID: $folderID
          createdAt: $createdAt
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      folderID
    };
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFolderScanTasksByFolderIDQuery>(
      response.data.listFolderScanTasksByFolderID
    );
  }
  async GetInvoiceScanTask(id: string): Promise<GetInvoiceScanTaskQuery> {
    const statement = `query GetInvoiceScanTask($id: ID!) {
        getInvoiceScanTask(id: $id) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          folderScanTaskID
          folderScanTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          createdByID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          logMessages
          queueID
          workerID
          worker {
            __typename
            id
            name
            status
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          executionTime
          status
          originalScanResults
          extractedProductsResults
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetInvoiceScanTaskQuery>response.data.getInvoiceScanTask;
  }
  async ListInvoiceScanTasks(
    filter?: ModelInvoiceScanTaskFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoiceScanTasksQuery> {
    const statement = `query ListInvoiceScanTasks($filter: ModelInvoiceScanTaskFilterInput, $limit: Int, $nextToken: String) {
        listInvoiceScanTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            invoiceID
            folderScanTaskID
            folderID
            createdByID
            logMessages
            queueID
            workerID
            extractedResults
            missingFields
            executionTime
            status
            originalScanResults
            extractedProductsResults
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoiceScanTasksQuery>response.data.listInvoiceScanTasks;
  }
  async GetInvoiceScanTaskByFolderScanTaskID(
    folderScanTaskID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelInvoiceScanTaskFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetInvoiceScanTaskByFolderScanTaskIDQuery> {
    const statement = `query GetInvoiceScanTaskByFolderScanTaskID($folderScanTaskID: ID!, $sortDirection: ModelSortDirection, $filter: ModelInvoiceScanTaskFilterInput, $limit: Int, $nextToken: String) {
        getInvoiceScanTaskByFolderScanTaskID(
          folderScanTaskID: $folderScanTaskID
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            invoiceID
            folderScanTaskID
            folderID
            createdByID
            logMessages
            queueID
            workerID
            extractedResults
            missingFields
            executionTime
            status
            originalScanResults
            extractedProductsResults
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      folderScanTaskID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetInvoiceScanTaskByFolderScanTaskIDQuery>(
      response.data.getInvoiceScanTaskByFolderScanTaskID
    );
  }
  async GetCodebook(id: string): Promise<GetCodebookQuery> {
    const statement = `query GetCodebook($id: ID!) {
        getCodebook(id: $id) {
          __typename
          id
          companyName
          searchKeyword
          idNumber
          code
          vatNumber
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetCodebookQuery>response.data.getCodebook;
  }
  async ListCodebooks(
    filter?: ModelCodebookFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListCodebooksQuery> {
    const statement = `query ListCodebooks($filter: ModelCodebookFilterInput, $limit: Int, $nextToken: String) {
        listCodebooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            companyName
            searchKeyword
            idNumber
            code
            vatNumber
            clientID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListCodebooksQuery>response.data.listCodebooks;
  }
  async GetCodebookByClientID(
    clientID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelCodebookFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetCodebookByClientIDQuery> {
    const statement = `query GetCodebookByClientID($clientID: ID!, $sortDirection: ModelSortDirection, $filter: ModelCodebookFilterInput, $limit: Int, $nextToken: String) {
        getCodebookByClientID(
          clientID: $clientID
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            companyName
            searchKeyword
            idNumber
            code
            vatNumber
            clientID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetCodebookByClientIDQuery>response.data.getCodebookByClientID;
  }
  async GetTemplate(id: string): Promise<GetTemplateQuery> {
    const statement = `query GetTemplate($id: ID!) {
        getTemplate(id: $id) {
          __typename
          id
          name
          searchKeyword
          description
          clientID
          template
          productsEnabled
          isFixedValueEnabled
          fixedValues
          clientIDProductsEnabledPK
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetTemplateQuery>response.data.getTemplate;
  }
  async ListTemplates(
    filter?: ModelTemplateFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTemplatesQuery> {
    const statement = `query ListTemplates($filter: ModelTemplateFilterInput, $limit: Int, $nextToken: String) {
        listTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            description
            clientID
            template
            productsEnabled
            isFixedValueEnabled
            fixedValues
            clientIDProductsEnabledPK
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTemplatesQuery>response.data.listTemplates;
  }
  async ListTemplatesByClientID(
    clientID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelTemplateFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTemplatesByClientIDQuery> {
    const statement = `query ListTemplatesByClientID($clientID: ID!, $sortDirection: ModelSortDirection, $filter: ModelTemplateFilterInput, $limit: Int, $nextToken: String) {
        listTemplatesByClientID(
          clientID: $clientID
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            description
            clientID
            template
            productsEnabled
            isFixedValueEnabled
            fixedValues
            clientIDProductsEnabledPK
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTemplatesByClientIDQuery>response.data.listTemplatesByClientID;
  }
  async ListTemplatesByProductsEnabled(
    productsEnabled: TF,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelTemplateFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTemplatesByProductsEnabledQuery> {
    const statement = `query ListTemplatesByProductsEnabled($productsEnabled: TF!, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelTemplateFilterInput, $limit: Int, $nextToken: String) {
        listTemplatesByProductsEnabled(
          productsEnabled: $productsEnabled
          createdAt: $createdAt
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            description
            clientID
            template
            productsEnabled
            isFixedValueEnabled
            fixedValues
            clientIDProductsEnabledPK
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      productsEnabled
    };
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTemplatesByProductsEnabledQuery>(
      response.data.listTemplatesByProductsEnabled
    );
  }
  async ListTemplatesByClientIDProductsEnabledPK(
    clientIDProductsEnabledPK: string,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelTemplateFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTemplatesByClientIDProductsEnabledPKQuery> {
    const statement = `query ListTemplatesByClientIDProductsEnabledPK($clientIDProductsEnabledPK: String!, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelTemplateFilterInput, $limit: Int, $nextToken: String) {
        listTemplatesByClientIDProductsEnabledPK(
          clientIDProductsEnabledPK: $clientIDProductsEnabledPK
          createdAt: $createdAt
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            description
            clientID
            template
            productsEnabled
            isFixedValueEnabled
            fixedValues
            clientIDProductsEnabledPK
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientIDProductsEnabledPK
    };
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTemplatesByClientIDProductsEnabledPKQuery>(
      response.data.listTemplatesByClientIDProductsEnabledPK
    );
  }
  async GetSystemConfiguration(
    id: string
  ): Promise<GetSystemConfigurationQuery> {
    const statement = `query GetSystemConfiguration($id: ID!) {
        getSystemConfiguration(id: $id) {
          __typename
          id
          value
          type
          note
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetSystemConfigurationQuery>response.data.getSystemConfiguration;
  }
  async ListSystemConfigurations(
    filter?: ModelSystemConfigurationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListSystemConfigurationsQuery> {
    const statement = `query ListSystemConfigurations($filter: ModelSystemConfigurationFilterInput, $limit: Int, $nextToken: String) {
        listSystemConfigurations(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            value
            type
            note
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSystemConfigurationsQuery>(
      response.data.listSystemConfigurations
    );
  }
  async ListSystemConfigurationsByType(
    type: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelSystemConfigurationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListSystemConfigurationsByTypeQuery> {
    const statement = `query ListSystemConfigurationsByType($type: String!, $sortDirection: ModelSortDirection, $filter: ModelSystemConfigurationFilterInput, $limit: Int, $nextToken: String) {
        listSystemConfigurationsByType(
          type: $type
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            value
            type
            note
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      type
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSystemConfigurationsByTypeQuery>(
      response.data.listSystemConfigurationsByType
    );
  }
  async GetWorker(id: string): Promise<GetWorkerQuery> {
    const statement = `query GetWorker($id: ID!) {
        getWorker(id: $id) {
          __typename
          id
          name
          status
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetWorkerQuery>response.data.getWorker;
  }
  async ListWorkers(
    filter?: ModelWorkerFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListWorkersQuery> {
    const statement = `query ListWorkers($filter: ModelWorkerFilterInput, $limit: Int, $nextToken: String) {
        listWorkers(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            status
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListWorkersQuery>response.data.listWorkers;
  }
  async GetMapperConfiguration(
    id: string
  ): Promise<GetMapperConfigurationQuery> {
    const statement = `query GetMapperConfiguration($id: ID!) {
        getMapperConfiguration(id: $id) {
          __typename
          id
          clientID
          type
          configuration
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetMapperConfigurationQuery>response.data.getMapperConfiguration;
  }
  async ListMapperConfigurations(
    filter?: ModelMapperConfigurationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListMapperConfigurationsQuery> {
    const statement = `query ListMapperConfigurations($filter: ModelMapperConfigurationFilterInput, $limit: Int, $nextToken: String) {
        listMapperConfigurations(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            clientID
            type
            configuration
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListMapperConfigurationsQuery>(
      response.data.listMapperConfigurations
    );
  }
  async GetMapperConfigurationByClientID(
    clientID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMapperConfigurationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetMapperConfigurationByClientIDQuery> {
    const statement = `query GetMapperConfigurationByClientID($clientID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMapperConfigurationFilterInput, $limit: Int, $nextToken: String) {
        getMapperConfigurationByClientID(
          clientID: $clientID
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            clientID
            type
            configuration
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetMapperConfigurationByClientIDQuery>(
      response.data.getMapperConfigurationByClientID
    );
  }
  async GetMapperConfigurationByType(
    type: MapConfigurationType,
    sortDirection?: ModelSortDirection,
    filter?: ModelMapperConfigurationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<GetMapperConfigurationByTypeQuery> {
    const statement = `query GetMapperConfigurationByType($type: MapConfigurationType!, $sortDirection: ModelSortDirection, $filter: ModelMapperConfigurationFilterInput, $limit: Int, $nextToken: String) {
        getMapperConfigurationByType(
          type: $type
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            clientID
            type
            configuration
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      type
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetMapperConfigurationByTypeQuery>(
      response.data.getMapperConfigurationByType
    );
  }
  async GetFiaReportJob(id: string): Promise<GetFiaReportJobQuery> {
    const statement = `query GetFiaReportJob($id: ID!) {
        getFiaReportJob(id: $id) {
          __typename
          id
          token
          userID
          status
          userIDStatusPK
          spreadSheetUrl
          proxySheetUrl
          sourceType
          source
          sourcePdf
          sourceDisplay
          errorMessage
          tableColumns
          selectedColumns {
            __typename
            fieldType
            index
            columnName
          }
          skipColumnSelection
          tablesJsonUrl
          previousSpreadsheetUrl
          permissionToEmail
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          exportedFileUrl
          missingKeys {
            __typename
            keys
            dismissed
          }
          companyName
          thumbnailUrls
          downloaded
          downloadedUserIDPK
          companyType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetFiaReportJobQuery>response.data.getFiaReportJob;
  }
  async ListFiaReportJobs(
    filter?: ModelFiaReportJobFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFiaReportJobsQuery> {
    const statement = `query ListFiaReportJobs($filter: ModelFiaReportJobFilterInput, $limit: Int, $nextToken: String) {
        listFiaReportJobs(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            token
            userID
            status
            userIDStatusPK
            spreadSheetUrl
            proxySheetUrl
            sourceType
            source
            sourcePdf
            sourceDisplay
            errorMessage
            tableColumns
            skipColumnSelection
            tablesJsonUrl
            previousSpreadsheetUrl
            permissionToEmail
            exportedFileUrl
            companyName
            thumbnailUrls
            downloaded
            downloadedUserIDPK
            companyType
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFiaReportJobsQuery>response.data.listFiaReportJobs;
  }
  async ListFiaReportJobsByUser(
    userID: string,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelFiaReportJobFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFiaReportJobsByUserQuery> {
    const statement = `query ListFiaReportJobsByUser($userID: ID!, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelFiaReportJobFilterInput, $limit: Int, $nextToken: String) {
        listFiaReportJobsByUser(
          userID: $userID
          createdAt: $createdAt
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            token
            userID
            status
            userIDStatusPK
            spreadSheetUrl
            proxySheetUrl
            sourceType
            source
            sourcePdf
            sourceDisplay
            errorMessage
            tableColumns
            skipColumnSelection
            tablesJsonUrl
            previousSpreadsheetUrl
            permissionToEmail
            exportedFileUrl
            companyName
            thumbnailUrls
            downloaded
            downloadedUserIDPK
            companyType
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      userID
    };
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFiaReportJobsByUserQuery>response.data.listFiaReportJobsByUser;
  }
  async ListFiaReportJobsByStatus(
    status: FiaReportJobStatus,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelFiaReportJobFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFiaReportJobsByStatusQuery> {
    const statement = `query ListFiaReportJobsByStatus($status: FiaReportJobStatus!, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelFiaReportJobFilterInput, $limit: Int, $nextToken: String) {
        listFiaReportJobsByStatus(
          status: $status
          createdAt: $createdAt
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            token
            userID
            status
            userIDStatusPK
            spreadSheetUrl
            proxySheetUrl
            sourceType
            source
            sourcePdf
            sourceDisplay
            errorMessage
            tableColumns
            skipColumnSelection
            tablesJsonUrl
            previousSpreadsheetUrl
            permissionToEmail
            exportedFileUrl
            companyName
            thumbnailUrls
            downloaded
            downloadedUserIDPK
            companyType
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      status
    };
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFiaReportJobsByStatusQuery>(
      response.data.listFiaReportJobsByStatus
    );
  }
  async ListFiaReportJobsByUserIDStatusPK(
    userIDStatusPK: string,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelFiaReportJobFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFiaReportJobsByUserIDStatusPKQuery> {
    const statement = `query ListFiaReportJobsByUserIDStatusPK($userIDStatusPK: String!, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelFiaReportJobFilterInput, $limit: Int, $nextToken: String) {
        listFiaReportJobsByUserIDStatusPK(
          userIDStatusPK: $userIDStatusPK
          createdAt: $createdAt
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            token
            userID
            status
            userIDStatusPK
            spreadSheetUrl
            proxySheetUrl
            sourceType
            source
            sourcePdf
            sourceDisplay
            errorMessage
            tableColumns
            skipColumnSelection
            tablesJsonUrl
            previousSpreadsheetUrl
            permissionToEmail
            exportedFileUrl
            companyName
            thumbnailUrls
            downloaded
            downloadedUserIDPK
            companyType
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      userIDStatusPK
    };
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFiaReportJobsByUserIDStatusPKQuery>(
      response.data.listFiaReportJobsByUserIDStatusPK
    );
  }
  OnCreateInvoiceListener(
    filter?: ModelSubscriptionInvoiceFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateInvoice">>
  > {
    const statement = `subscription OnCreateInvoice($filter: ModelSubscriptionInvoiceFilterInput, $clientID: String) {
        onCreateInvoice(filter: $filter, clientID: $clientID) {
          __typename
          id
          name
          folderID
          folderIDIsDeletedPK
          clientID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          thumbnailPath
          invoiceScanTasks {
            __typename
            nextToken
          }
          index
          extractedProductsResults
          isLatestScanIncludedProducts
          rotateAngle
          invoiceUserAssignments {
            __typename
            nextToken
          }
          createdAt
          updatedAt
          nanonets {
            __typename
            previewUrl
            fileID
            modelID
            expiresAt
            redirectUrl
          }
          nanonetsID
          title
          searchToken
          isDeleted
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateInvoice">>
    >;
  }

  OnUpdateInvoiceListener(
    filter?: ModelSubscriptionInvoiceFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateInvoice">>
  > {
    const statement = `subscription OnUpdateInvoice($filter: ModelSubscriptionInvoiceFilterInput, $clientID: String) {
        onUpdateInvoice(filter: $filter, clientID: $clientID) {
          __typename
          id
          name
          folderID
          folderIDIsDeletedPK
          clientID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          thumbnailPath
          invoiceScanTasks {
            __typename
            nextToken
          }
          index
          extractedProductsResults
          isLatestScanIncludedProducts
          rotateAngle
          invoiceUserAssignments {
            __typename
            nextToken
          }
          createdAt
          updatedAt
          nanonets {
            __typename
            previewUrl
            fileID
            modelID
            expiresAt
            redirectUrl
          }
          nanonetsID
          title
          searchToken
          isDeleted
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateInvoice">>
    >;
  }

  OnUpdateUserListener(
    filter?: ModelSubscriptionUserFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateUser">>
  > {
    const statement = `subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
        onUpdateUser(filter: $filter) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          status
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateUser">>
    >;
  }

  OnDeleteUserListener(
    filter?: ModelSubscriptionUserFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteUser">>
  > {
    const statement = `subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
        onDeleteUser(filter: $filter) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          status
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteUser">>
    >;
  }

  OnUpdateClientListener(
    filter?: ModelSubscriptionClientFilterInput,
    id?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateClient">>
  > {
    const statement = `subscription OnUpdateClient($filter: ModelSubscriptionClientFilterInput, $id: String) {
        onUpdateClient(filter: $filter, id: $id) {
          __typename
          id
          username
          email
          firstName
          lastName
          company
          phone
          address
          city
          folders {
            __typename
            nextToken
          }
          folderScanTasks {
            __typename
            nextToken
          }
          totalScanCount
          expirationDate
          isVatIncluded
          status
          userID
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            status
            type
            createdAt
            updatedAt
          }
          viberID
          totalFiaReportProcessCount
          fiaAccessStatus
          createdAt
          updatedAt
          downloadQuota
          reportQuota
          downloadedCount
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (id) {
      gqlAPIServiceArguments.id = id;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateClient">>
    >;
  }

  OnCreateFolderListener(
    filter?: ModelSubscriptionFolderFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateFolder">>
  > {
    const statement = `subscription OnCreateFolder($filter: ModelSubscriptionFolderFilterInput, $clientID: String) {
        onCreateFolder(filter: $filter, clientID: $clientID) {
          __typename
          id
          name
          searchKeyword
          clientID
          downloadLink
          status
          latestFolderInvoiceTaskID
          areThereMissingFields
          invoicesCount
          invoices {
            __typename
            nextToken
          }
          latestFolderInvoiceTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderScanTasks {
            __typename
            nextToken
          }
          exportStatus
          latestCompletedAt
          isLatestScanIncludedProducts
          parentFolderID
          parentFolder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          childFolders {
            __typename
            nextToken
          }
          clientIDParentFolderIDPK
          isDeleted
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateFolder">>
    >;
  }

  OnUpdateFolderListener(
    filter?: ModelSubscriptionFolderFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateFolder">>
  > {
    const statement = `subscription OnUpdateFolder($filter: ModelSubscriptionFolderFilterInput, $clientID: String) {
        onUpdateFolder(filter: $filter, clientID: $clientID) {
          __typename
          id
          name
          searchKeyword
          clientID
          downloadLink
          status
          latestFolderInvoiceTaskID
          areThereMissingFields
          invoicesCount
          invoices {
            __typename
            nextToken
          }
          latestFolderInvoiceTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderScanTasks {
            __typename
            nextToken
          }
          exportStatus
          latestCompletedAt
          isLatestScanIncludedProducts
          parentFolderID
          parentFolder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          childFolders {
            __typename
            nextToken
          }
          clientIDParentFolderIDPK
          isDeleted
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateFolder">>
    >;
  }

  OnUpdateInvoiceUserAssignmentListener(
    filter?: ModelSubscriptionInvoiceUserAssignmentFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateInvoiceUserAssignment">
    >
  > {
    const statement = `subscription OnUpdateInvoiceUserAssignment($filter: ModelSubscriptionInvoiceUserAssignmentFilterInput, $clientID: String) {
        onUpdateInvoiceUserAssignment(filter: $filter, clientID: $clientID) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          email
          role
          notified
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateInvoiceUserAssignment">
      >
    >;
  }

  OnUpdateFolderScanTaskListener(
    filter?: ModelSubscriptionFolderScanTaskFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateFolderScanTask">
    >
  > {
    const statement = `subscription OnUpdateFolderScanTask($filter: ModelSubscriptionFolderScanTaskFilterInput, $clientID: String) {
        onUpdateFolderScanTask(filter: $filter, clientID: $clientID) {
          __typename
          id
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          clientID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          taskCount
          processedTaskCount
          failedTaskCount
          executionTime
          logMessages
          status
          extractedResults
          missingFieldsCount
          invoiceScanTasks {
            __typename
            nextToken
          }
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateFolderScanTask">
      >
    >;
  }

  OnCreateInvoiceScanTaskListener(
    filter?: ModelSubscriptionInvoiceScanTaskFilterInput,
    createdByID?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onCreateInvoiceScanTask">
    >
  > {
    const statement = `subscription OnCreateInvoiceScanTask($filter: ModelSubscriptionInvoiceScanTaskFilterInput, $createdByID: String) {
        onCreateInvoiceScanTask(filter: $filter, createdByID: $createdByID) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          folderScanTaskID
          folderScanTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          createdByID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          logMessages
          queueID
          workerID
          worker {
            __typename
            id
            name
            status
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          executionTime
          status
          originalScanResults
          extractedProductsResults
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (createdByID) {
      gqlAPIServiceArguments.createdByID = createdByID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onCreateInvoiceScanTask">
      >
    >;
  }

  OnUpdateInvoiceScanTaskListener(
    filter?: ModelSubscriptionInvoiceScanTaskFilterInput,
    createdByID?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateInvoiceScanTask">
    >
  > {
    const statement = `subscription OnUpdateInvoiceScanTask($filter: ModelSubscriptionInvoiceScanTaskFilterInput, $createdByID: String) {
        onUpdateInvoiceScanTask(filter: $filter, createdByID: $createdByID) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          folderScanTaskID
          folderScanTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          createdByID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          logMessages
          queueID
          workerID
          worker {
            __typename
            id
            name
            status
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          executionTime
          status
          originalScanResults
          extractedProductsResults
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (createdByID) {
      gqlAPIServiceArguments.createdByID = createdByID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateInvoiceScanTask">
      >
    >;
  }

  OnDeleteInvoiceScanTaskListener(
    filter?: ModelSubscriptionInvoiceScanTaskFilterInput,
    createdByID?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onDeleteInvoiceScanTask">
    >
  > {
    const statement = `subscription OnDeleteInvoiceScanTask($filter: ModelSubscriptionInvoiceScanTaskFilterInput, $createdByID: String) {
        onDeleteInvoiceScanTask(filter: $filter, createdByID: $createdByID) {
          __typename
          id
          invoiceID
          invoice {
            __typename
            id
            name
            folderID
            folderIDIsDeletedPK
            clientID
            extractedResults
            missingFields
            thumbnailPath
            index
            extractedProductsResults
            isLatestScanIncludedProducts
            rotateAngle
            createdAt
            updatedAt
            nanonetsID
            title
            searchToken
            isDeleted
          }
          folderScanTaskID
          folderScanTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            isScanIncludedProducts
            createdAt
            updatedAt
          }
          folderID
          folder {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            createdAt
            updatedAt
          }
          createdByID
          client {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          logMessages
          queueID
          workerID
          worker {
            __typename
            id
            name
            status
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          executionTime
          status
          originalScanResults
          extractedProductsResults
          isScanIncludedProducts
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (createdByID) {
      gqlAPIServiceArguments.createdByID = createdByID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onDeleteInvoiceScanTask">
      >
    >;
  }

  OnCreateCodebookListener(
    filter?: ModelSubscriptionCodebookFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateCodebook">>
  > {
    const statement = `subscription OnCreateCodebook($filter: ModelSubscriptionCodebookFilterInput, $clientID: String) {
        onCreateCodebook(filter: $filter, clientID: $clientID) {
          __typename
          id
          companyName
          searchKeyword
          idNumber
          code
          vatNumber
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateCodebook">>
    >;
  }

  OnUpdateCodebookListener(
    filter?: ModelSubscriptionCodebookFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateCodebook">>
  > {
    const statement = `subscription OnUpdateCodebook($filter: ModelSubscriptionCodebookFilterInput, $clientID: String) {
        onUpdateCodebook(filter: $filter, clientID: $clientID) {
          __typename
          id
          companyName
          searchKeyword
          idNumber
          code
          vatNumber
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateCodebook">>
    >;
  }

  OnDeleteCodebookListener(
    filter?: ModelSubscriptionCodebookFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteCodebook">>
  > {
    const statement = `subscription OnDeleteCodebook($filter: ModelSubscriptionCodebookFilterInput, $clientID: String) {
        onDeleteCodebook(filter: $filter, clientID: $clientID) {
          __typename
          id
          companyName
          searchKeyword
          idNumber
          code
          vatNumber
          clientID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteCodebook">>
    >;
  }

  OnCreateTemplateListener(
    filter?: ModelSubscriptionTemplateFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTemplate">>
  > {
    const statement = `subscription OnCreateTemplate($filter: ModelSubscriptionTemplateFilterInput) {
        onCreateTemplate(filter: $filter) {
          __typename
          id
          name
          searchKeyword
          description
          clientID
          template
          productsEnabled
          clientIDProductsEnabledPK
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateTemplate">>
    >;
  }

  OnUpdateTemplateListener(
    filter?: ModelSubscriptionTemplateFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTemplate">>
  > {
    const statement = `subscription OnUpdateTemplate($filter: ModelSubscriptionTemplateFilterInput) {
        onUpdateTemplate(filter: $filter) {
          __typename
          id
          name
          searchKeyword
          description
          clientID
          template
          productsEnabled
          clientIDProductsEnabledPK
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateTemplate">>
    >;
  }

  OnDeleteTemplateListener(
    filter?: ModelSubscriptionTemplateFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTemplate">>
  > {
    const statement = `subscription OnDeleteTemplate($filter: ModelSubscriptionTemplateFilterInput) {
        onDeleteTemplate(filter: $filter) {
          __typename
          id
          name
          searchKeyword
          description
          clientID
          template
          productsEnabled
          clientIDProductsEnabledPK
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteTemplate">>
    >;
  }

  OnCreateSystemConfigurationListener(
    filter?: ModelSubscriptionSystemConfigurationFilterInput
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onCreateSystemConfiguration">
    >
  > {
    const statement = `subscription OnCreateSystemConfiguration($filter: ModelSubscriptionSystemConfigurationFilterInput) {
        onCreateSystemConfiguration(filter: $filter) {
          __typename
          id
          value
          type
          note
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onCreateSystemConfiguration">
      >
    >;
  }

  OnUpdateSystemConfigurationListener(
    filter?: ModelSubscriptionSystemConfigurationFilterInput
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateSystemConfiguration">
    >
  > {
    const statement = `subscription OnUpdateSystemConfiguration($filter: ModelSubscriptionSystemConfigurationFilterInput) {
        onUpdateSystemConfiguration(filter: $filter) {
          __typename
          id
          value
          type
          note
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateSystemConfiguration">
      >
    >;
  }

  OnDeleteSystemConfigurationListener(
    filter?: ModelSubscriptionSystemConfigurationFilterInput
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onDeleteSystemConfiguration">
    >
  > {
    const statement = `subscription OnDeleteSystemConfiguration($filter: ModelSubscriptionSystemConfigurationFilterInput) {
        onDeleteSystemConfiguration(filter: $filter) {
          __typename
          id
          value
          type
          note
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onDeleteSystemConfiguration">
      >
    >;
  }

  OnCreateWorkerListener(
    filter?: ModelSubscriptionWorkerFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateWorker">>
  > {
    const statement = `subscription OnCreateWorker($filter: ModelSubscriptionWorkerFilterInput) {
        onCreateWorker(filter: $filter) {
          __typename
          id
          name
          status
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateWorker">>
    >;
  }

  OnUpdateWorkerListener(
    filter?: ModelSubscriptionWorkerFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateWorker">>
  > {
    const statement = `subscription OnUpdateWorker($filter: ModelSubscriptionWorkerFilterInput) {
        onUpdateWorker(filter: $filter) {
          __typename
          id
          name
          status
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateWorker">>
    >;
  }

  OnDeleteWorkerListener(
    filter?: ModelSubscriptionWorkerFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteWorker">>
  > {
    const statement = `subscription OnDeleteWorker($filter: ModelSubscriptionWorkerFilterInput) {
        onDeleteWorker(filter: $filter) {
          __typename
          id
          name
          status
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteWorker">>
    >;
  }

  OnUpdateMapperConfigurationListener(
    filter?: ModelSubscriptionMapperConfigurationFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateMapperConfiguration">
    >
  > {
    const statement = `subscription OnUpdateMapperConfiguration($filter: ModelSubscriptionMapperConfigurationFilterInput, $clientID: String) {
        onUpdateMapperConfiguration(filter: $filter, clientID: $clientID) {
          __typename
          id
          clientID
          type
          configuration
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateMapperConfiguration">
      >
    >;
  }

  OnDeleteMapperConfigurationListener(
    filter?: ModelSubscriptionMapperConfigurationFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onDeleteMapperConfiguration">
    >
  > {
    const statement = `subscription OnDeleteMapperConfiguration($filter: ModelSubscriptionMapperConfigurationFilterInput, $clientID: String) {
        onDeleteMapperConfiguration(filter: $filter, clientID: $clientID) {
          __typename
          id
          clientID
          type
          configuration
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onDeleteMapperConfiguration">
      >
    >;
  }

  OnCreateFiaReportJobListener(
    filter?: ModelSubscriptionFiaReportJobFilterInput,
    userID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateFiaReportJob">>
  > {
    const statement = `subscription OnCreateFiaReportJob($filter: ModelSubscriptionFiaReportJobFilterInput, $userID: String) {
        onCreateFiaReportJob(filter: $filter, userID: $userID) {
          __typename
          id
          token
          userID
          status
          userIDStatusPK
          spreadSheetUrl
          proxySheetUrl
          sourceType
          source
          sourcePdf
          sourceDisplay
          errorMessage
          tableColumns
          selectedColumns {
            __typename
            fieldType
            index
            columnName
          }
          skipColumnSelection
          tablesJsonUrl
          previousSpreadsheetUrl
          permissionToEmail
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          exportedFileUrl
          missingKeys {
            __typename
            keys
            dismissed
          }
          companyName
          thumbnailUrls
          downloaded
          downloadedUserIDPK
          companyType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (userID) {
      gqlAPIServiceArguments.userID = userID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onCreateFiaReportJob">
      >
    >;
  }

  OnUpdateFiaReportJobListener(
    filter?: ModelSubscriptionFiaReportJobFilterInput,
    userID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateFiaReportJob">>
  > {
    const statement = `subscription OnUpdateFiaReportJob($filter: ModelSubscriptionFiaReportJobFilterInput, $userID: String) {
        onUpdateFiaReportJob(filter: $filter, userID: $userID) {
          __typename
          id
          token
          userID
          status
          userIDStatusPK
          spreadSheetUrl
          proxySheetUrl
          sourceType
          source
          sourcePdf
          sourceDisplay
          errorMessage
          tableColumns
          selectedColumns {
            __typename
            fieldType
            index
            columnName
          }
          skipColumnSelection
          tablesJsonUrl
          previousSpreadsheetUrl
          permissionToEmail
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          exportedFileUrl
          missingKeys {
            __typename
            keys
            dismissed
          }
          companyName
          thumbnailUrls
          downloaded
          downloadedUserIDPK
          companyType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (userID) {
      gqlAPIServiceArguments.userID = userID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateFiaReportJob">
      >
    >;
  }

  OnDeleteFiaReportJobListener(
    filter?: ModelSubscriptionFiaReportJobFilterInput,
    userID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteFiaReportJob">>
  > {
    const statement = `subscription OnDeleteFiaReportJob($filter: ModelSubscriptionFiaReportJobFilterInput, $userID: String) {
        onDeleteFiaReportJob(filter: $filter, userID: $userID) {
          __typename
          id
          token
          userID
          status
          userIDStatusPK
          spreadSheetUrl
          proxySheetUrl
          sourceType
          source
          sourcePdf
          sourceDisplay
          errorMessage
          tableColumns
          selectedColumns {
            __typename
            fieldType
            index
            columnName
          }
          skipColumnSelection
          tablesJsonUrl
          previousSpreadsheetUrl
          permissionToEmail
          user {
            __typename
            id
            username
            email
            firstName
            lastName
            company
            phone
            address
            city
            totalScanCount
            expirationDate
            isVatIncluded
            status
            userID
            viberID
            totalFiaReportProcessCount
            fiaAccessStatus
            createdAt
            updatedAt
            downloadQuota
            reportQuota
            downloadedCount
          }
          exportedFileUrl
          missingKeys {
            __typename
            keys
            dismissed
          }
          companyName
          thumbnailUrls
          downloaded
          downloadedUserIDPK
          companyType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (userID) {
      gqlAPIServiceArguments.userID = userID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onDeleteFiaReportJob">
      >
    >;
  }
}
